var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHappycustomer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 428.873,
    height: 444.64,
    viewBox: "0 0 428.873 444.64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "happycustomer",
    transform: "translate(-33.27 -33.045)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Background_Complete",
    "data-name": "Background Complete"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3557",
    "data-name": "Group 3557"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3420",
    "data-name": "Group 3420"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3153",
    "data-name": "Group 3153"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3116",
    "data-name": "Group 3116"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3115",
    "data-name": "Group 3115"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3114",
    "data-name": "Group 3114"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3113",
    "data-name": "Group 3113"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3112",
    "data-name": "Group 3112"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1822",
    "data-name": "Path 1822",
    d: "M52.283,126.529s-6.062,4.618-.254,10.72a.525.525,0,0,0,.384.163l52.963-.309s4.523-5.073.77-10.919Z",
    fill: "#ebebeb"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3122",
    "data-name": "Group 3122"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3121",
    "data-name": "Group 3121"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3120",
    "data-name": "Group 3120"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3119",
    "data-name": "Group 3119"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3118",
    "data-name": "Group 3118"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3117",
    "data-name": "Group 3117"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1823",
    "data-name": "Path 1823",
    d: "M93.671,131.35c0,.059-6.6.107-14.729.107s-14.73-.048-14.73-.107,6.594-.107,14.73-.107S93.671,131.29,93.671,131.35Z",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3128",
    "data-name": "Group 3128"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3127",
    "data-name": "Group 3127"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3126",
    "data-name": "Group 3126"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3125",
    "data-name": "Group 3125"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3124",
    "data-name": "Group 3124"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3123",
    "data-name": "Group 3123"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1824",
    "data-name": "Path 1824",
    d: "M85.433,133.266c0,.059-3.1.107-6.925.107s-6.925-.048-6.925-.107,3.1-.107,6.925-.107S85.433,133.206,85.433,133.266Z",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3134",
    "data-name": "Group 3134"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3133",
    "data-name": "Group 3133"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3132",
    "data-name": "Group 3132"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3131",
    "data-name": "Group 3131"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3130",
    "data-name": "Group 3130"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3129",
    "data-name": "Group 3129"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1825",
    "data-name": "Path 1825",
    d: "M99.086,136.933c-.034-.009.117-.608.281-1.589a21.941,21.941,0,0,0-.073-7.723c-.183-.977-.345-1.573-.311-1.583a1.678,1.678,0,0,1,.154.407c.088.266.194.658.305,1.146a18.754,18.754,0,0,1,.074,7.781c-.1.49-.2.883-.284,1.151A1.63,1.63,0,0,1,99.086,136.933Z",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3140",
    "data-name": "Group 3140"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3139",
    "data-name": "Group 3139"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3138",
    "data-name": "Group 3138"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3137",
    "data-name": "Group 3137"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3136",
    "data-name": "Group 3136"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3135",
    "data-name": "Group 3135"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1826",
    "data-name": "Path 1826",
    d: "M103.039,126.118a1.832,1.832,0,0,1,.236.385,4.654,4.654,0,0,1,.235.474c.083.19.187.4.271.648a11.393,11.393,0,0,1,.5,1.758,11.84,11.84,0,0,1,.036,4.461,11.278,11.278,0,0,1-.476,1.765c-.079.248-.18.462-.26.653a4.905,4.905,0,0,1-.227.478,1.816,1.816,0,0,1-.23.388c-.037-.018.258-.588.574-1.567a12.667,12.667,0,0,0,.424-1.751,12.611,12.611,0,0,0-.035-4.39,12.661,12.661,0,0,0-.453-1.744C103.307,126.7,103,126.137,103.039,126.118Z",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3146",
    "data-name": "Group 3146"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3145",
    "data-name": "Group 3145"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3144",
    "data-name": "Group 3144"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3143",
    "data-name": "Group 3143"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3142",
    "data-name": "Group 3142"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3141",
    "data-name": "Group 3141"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1827",
    "data-name": "Path 1827",
    d: "M60.64,137a1.615,1.615,0,0,1-.247-.354,3.782,3.782,0,0,1-.248-.442,6.251,6.251,0,0,1-.282-.609,9.245,9.245,0,0,1-.517-1.671,9.837,9.837,0,0,1,.057-4.261,9.258,9.258,0,0,1,.562-1.657,6.008,6.008,0,0,1,.3-.6,3.755,3.755,0,0,1,.259-.435,1.649,1.649,0,0,1,.256-.347c.036.022-.305.534-.675,1.443a10.224,10.224,0,0,0-.508,1.641,10.38,10.38,0,0,0-.057,4.179A10.386,10.386,0,0,0,60,135.544C60.349,136.462,60.676,136.983,60.64,137Z",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3152",
    "data-name": "Group 3152"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3151",
    "data-name": "Group 3151"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3150",
    "data-name": "Group 3150"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3149",
    "data-name": "Group 3149"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3148",
    "data-name": "Group 3148"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3147",
    "data-name": "Group 3147"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1828",
    "data-name": "Path 1828",
    d: "M54.921,138.3a2.028,2.028,0,0,1-.272-.4,4.564,4.564,0,0,1-.277-.5,7.326,7.326,0,0,1-.32-.683,11.3,11.3,0,0,1-.607-1.87,11.835,11.835,0,0,1-.106-4.791,11.319,11.319,0,0,1,.523-1.894c.088-.266.2-.493.29-.7a4.531,4.531,0,0,1,.254-.509,2.136,2.136,0,0,1,.254-.413c.039.02-.3.622-.655,1.669a12.456,12.456,0,0,0-.472,1.879,12.488,12.488,0,0,0,.1,4.714,12.481,12.481,0,0,0,.554,1.855C54.593,137.687,54.958,138.274,54.921,138.3Z",
    fill: "#e0e0e0"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3230",
    "data-name": "Group 3230"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3194",
    "data-name": "Group 3194"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3158",
    "data-name": "Group 3158"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3157",
    "data-name": "Group 3157"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3156",
    "data-name": "Group 3156"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3155",
    "data-name": "Group 3155"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3154",
    "data-name": "Group 3154"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1829",
    "data-name": "Path 1829",
    d: "M103.434,153.233v10.135H83.821V153.233Z",
    fill: "#ebebeb"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3163",
    "data-name": "Group 3163"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3162",
    "data-name": "Group 3162"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3161",
    "data-name": "Group 3161"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3160",
    "data-name": "Group 3160"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3159",
    "data-name": "Group 3159"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1830",
    "data-name": "Path 1830",
    d: "M40.094,158.4c0,.089.007.178.012.268A5.806,5.806,0,0,0,45.94,164.1h58.408v-.733H90.482a5.068,5.068,0,0,1-5.067-5.067h0a5.068,5.068,0,0,1,5.067-5.068h13.866v-1.077l-58.426.2A5.844,5.844,0,0,0,40.094,158.4Z",
    fill: "#e0e0e0"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3169",
    "data-name": "Group 3169"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3168",
    "data-name": "Group 3168"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3167",
    "data-name": "Group 3167"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3166",
    "data-name": "Group 3166"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3165",
    "data-name": "Group 3165"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3164",
    "data-name": "Group 3164"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1831",
    "data-name": "Path 1831",
    d: "M103.434,158.436c0,.059-4.033.107-9.006.107s-9.006-.048-9.006-.107,4.031-.107,9.006-.107S103.434,158.377,103.434,158.436Z",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3175",
    "data-name": "Group 3175"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3174",
    "data-name": "Group 3174"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3173",
    "data-name": "Group 3173"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3172",
    "data-name": "Group 3172"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3171",
    "data-name": "Group 3171"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3170",
    "data-name": "Group 3170"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1832",
    "data-name": "Path 1832",
    d: "M103.15,160.72c0,.059-3.816.107-8.522.107s-8.522-.048-8.522-.107,3.815-.107,8.522-.107S103.15,160.661,103.15,160.72Z",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3181",
    "data-name": "Group 3181"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3180",
    "data-name": "Group 3180"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3179",
    "data-name": "Group 3179"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3178",
    "data-name": "Group 3178"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3177",
    "data-name": "Group 3177"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3176",
    "data-name": "Group 3176"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1833",
    "data-name": "Path 1833",
    d: "M103.434,162.808c0,.059-3.431.107-7.662.107s-7.662-.048-7.662-.107,3.43-.107,7.662-.107S103.434,162.749,103.434,162.808Z",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3187",
    "data-name": "Group 3187"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3186",
    "data-name": "Group 3186"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3185",
    "data-name": "Group 3185"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3184",
    "data-name": "Group 3184"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3183",
    "data-name": "Group 3183"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3182",
    "data-name": "Group 3182"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1834",
    "data-name": "Path 1834",
    d: "M103.434,156.384c0,.059-3.95.107-8.822.107s-8.822-.048-8.822-.107,3.95-.107,8.822-.107S103.434,156.325,103.434,156.384Z",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3193",
    "data-name": "Group 3193"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3192",
    "data-name": "Group 3192"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3191",
    "data-name": "Group 3191"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3190",
    "data-name": "Group 3190"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3189",
    "data-name": "Group 3189"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3188",
    "data-name": "Group 3188"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1835",
    "data-name": "Path 1835",
    d: "M103.15,154.332c0,.059-3.516.107-7.852.107s-7.853-.048-7.853-.107,3.516-.107,7.853-.107S103.15,154.273,103.15,154.332Z",
    fill: "#e0e0e0"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3200",
    "data-name": "Group 3200"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3199",
    "data-name": "Group 3199"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3198",
    "data-name": "Group 3198"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3197",
    "data-name": "Group 3197"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3196",
    "data-name": "Group 3196"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3195",
    "data-name": "Group 3195"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1836",
    "data-name": "Path 1836",
    d: "M47.171,152.523A12.893,12.893,0,0,0,45.93,154a7.505,7.505,0,0,0,.1,8.685,12.942,12.942,0,0,0,1.276,1.446,2.009,2.009,0,0,1-.422-.311,6.712,6.712,0,0,1-.976-1.045,7.394,7.394,0,0,1-.1-8.862,6.663,6.663,0,0,1,.95-1.068A2.061,2.061,0,0,1,47.171,152.523Z",
    fill: "#f5f5f5"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3206",
    "data-name": "Group 3206"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3205",
    "data-name": "Group 3205"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3204",
    "data-name": "Group 3204"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3203",
    "data-name": "Group 3203"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3202",
    "data-name": "Group 3202"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3201",
    "data-name": "Group 3201"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1837",
    "data-name": "Path 1837",
    d: "M45.2,152.307a12.891,12.891,0,0,0-1.241,1.476,7.505,7.505,0,0,0,.1,8.685,12.94,12.94,0,0,0,1.276,1.446,2.009,2.009,0,0,1-.422-.311,6.682,6.682,0,0,1-.976-1.046,7.392,7.392,0,0,1-.1-8.861,6.662,6.662,0,0,1,.95-1.068A2.061,2.061,0,0,1,45.2,152.307Z",
    fill: "#f5f5f5"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3212",
    "data-name": "Group 3212"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3211",
    "data-name": "Group 3211"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3210",
    "data-name": "Group 3210"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3209",
    "data-name": "Group 3209"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3208",
    "data-name": "Group 3208"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3207",
    "data-name": "Group 3207"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1838",
    "data-name": "Path 1838",
    d: "M84.883,152.523A12.893,12.893,0,0,0,83.642,154a7.505,7.505,0,0,0,.1,8.685,12.943,12.943,0,0,0,1.276,1.446,2.009,2.009,0,0,1-.422-.311,6.761,6.761,0,0,1-.976-1.045,7.394,7.394,0,0,1-.1-8.862,6.663,6.663,0,0,1,.95-1.068A2.061,2.061,0,0,1,84.883,152.523Z",
    fill: "#f5f5f5"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3218",
    "data-name": "Group 3218"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3217",
    "data-name": "Group 3217"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3216",
    "data-name": "Group 3216"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3215",
    "data-name": "Group 3215"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3214",
    "data-name": "Group 3214"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3213",
    "data-name": "Group 3213"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1839",
    "data-name": "Path 1839",
    d: "M82.908,152.307a12.891,12.891,0,0,0-1.241,1.476,7.505,7.505,0,0,0,.1,8.685,12.94,12.94,0,0,0,1.276,1.446,2.009,2.009,0,0,1-.422-.311,6.682,6.682,0,0,1-.976-1.046,7.392,7.392,0,0,1-.1-8.861,6.662,6.662,0,0,1,.95-1.068A2.061,2.061,0,0,1,82.908,152.307Z",
    fill: "#f5f5f5"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3223",
    "data-name": "Group 3223"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3222",
    "data-name": "Group 3222"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3221",
    "data-name": "Group 3221"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3220",
    "data-name": "Group 3220"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3219",
    "data-name": "Group 3219"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1840",
    "data-name": "Path 1840",
    d: "M53.818,159.819q-.029-2.06-.056-4.121a2.935,2.935,0,0,0-.145-1.061,1,1,0,0,0-.782-.661,1.567,1.567,0,0,0-1.681.8,3.911,3.911,0,0,0-.406,2.019,29.261,29.261,0,0,0,.159,3.256,3.743,3.743,0,0,0,.383,1.49,1.391,1.391,0,0,0,1.257.756,1.407,1.407,0,0,0,1.1-.956A4.166,4.166,0,0,0,53.818,159.819Z",
    fill: "#f5f5f5"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3229",
    "data-name": "Group 3229"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3228",
    "data-name": "Group 3228"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3227",
    "data-name": "Group 3227"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3226",
    "data-name": "Group 3226"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3225",
    "data-name": "Group 3225"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3224",
    "data-name": "Group 3224"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1841",
    "data-name": "Path 1841",
    d: "M76.5,158.634c0,.059-4.222.107-9.43.107s-9.431-.048-9.431-.107,4.222-.107,9.431-.107S76.5,158.575,76.5,158.634Z",
    fill: "#f5f5f5"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3384",
    "data-name": "Group 3384"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3321",
    "data-name": "Group 3321"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3266",
    "data-name": "Group 3266"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3235",
    "data-name": "Group 3235"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3234",
    "data-name": "Group 3234"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3233",
    "data-name": "Group 3233"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3232",
    "data-name": "Group 3232"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3231",
    "data-name": "Group 3231"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1842",
    "data-name": "Path 1842",
    d: "M49.905,152.118l-.108-9.607h5.23l.18,9.607Z",
    fill: "#f5f5f5"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3241",
    "data-name": "Group 3241"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3240",
    "data-name": "Group 3240"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3239",
    "data-name": "Group 3239"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3238",
    "data-name": "Group 3238"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3237",
    "data-name": "Group 3237"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3236",
    "data-name": "Group 3236"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1843",
    "data-name": "Path 1843",
    d: "M54.718,144.22a13.9,13.9,0,0,1-2.43.107,13.908,13.908,0,0,1-2.431-.107,13.908,13.908,0,0,1,2.431-.107A13.9,13.9,0,0,1,54.718,144.22Z",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3247",
    "data-name": "Group 3247"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3246",
    "data-name": "Group 3246"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3245",
    "data-name": "Group 3245"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3244",
    "data-name": "Group 3244"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3243",
    "data-name": "Group 3243"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3242",
    "data-name": "Group 3242"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1844",
    "data-name": "Path 1844",
    d: "M54.718,145.7a13.9,13.9,0,0,1-2.43.107,13.91,13.91,0,0,1-2.431-.107,13.907,13.907,0,0,1,2.431-.107A13.9,13.9,0,0,1,54.718,145.7Z",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3253",
    "data-name": "Group 3253"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3252",
    "data-name": "Group 3252"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3251",
    "data-name": "Group 3251"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3250",
    "data-name": "Group 3250"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3249",
    "data-name": "Group 3249"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3248",
    "data-name": "Group 3248"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1845",
    "data-name": "Path 1845",
    d: "M54.718,147.186a13.9,13.9,0,0,1-2.43.107,13.91,13.91,0,0,1-2.431-.107,13.907,13.907,0,0,1,2.431-.107A13.9,13.9,0,0,1,54.718,147.186Z",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3259",
    "data-name": "Group 3259"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3258",
    "data-name": "Group 3258"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3257",
    "data-name": "Group 3257"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3256",
    "data-name": "Group 3256"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3255",
    "data-name": "Group 3255"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3254",
    "data-name": "Group 3254"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1846",
    "data-name": "Path 1846",
    d: "M54.718,148.669a13.9,13.9,0,0,1-2.43.107,13.91,13.91,0,0,1-2.431-.107,13.907,13.907,0,0,1,2.431-.107A13.9,13.9,0,0,1,54.718,148.669Z",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3265",
    "data-name": "Group 3265"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3264",
    "data-name": "Group 3264"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3263",
    "data-name": "Group 3263"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3262",
    "data-name": "Group 3262"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3261",
    "data-name": "Group 3261"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3260",
    "data-name": "Group 3260"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1847",
    "data-name": "Path 1847",
    d: "M54.718,150.151a13.786,13.786,0,0,1-2.43.107,13.793,13.793,0,0,1-2.431-.107,13.908,13.908,0,0,1,2.431-.107A13.9,13.9,0,0,1,54.718,150.151Z",
    fill: "#e0e0e0"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3271",
    "data-name": "Group 3271"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3270",
    "data-name": "Group 3270"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3269",
    "data-name": "Group 3269"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3268",
    "data-name": "Group 3268"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3267",
    "data-name": "Group 3267"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1848",
    "data-name": "Path 1848",
    d: "M49.519,142.257H107.48a27.256,27.256,0,0,1,0,10.384H49.767v-.707h3.526a1.665,1.665,0,0,0,1.666-1.665v-5.746a1.666,1.666,0,0,0-1.666-1.666H49.519Z",
    fill: "#ebebeb"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3296",
    "data-name": "Group 3296"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3275",
    "data-name": "Group 3275"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3274",
    "data-name": "Group 3274"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3273",
    "data-name": "Group 3273"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3272",
    "data-name": "Group 3272"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1849",
    "data-name": "Path 1849",
    d: "M63.222,147.455h.967a.226.226,0,0,1,.1.026.2.2,0,0,1,.1.182.191.191,0,0,1-.008.062c-.019.082-.041.164-.065.247a2.753,2.753,0,0,1-.606,1.1,1.143,1.143,0,0,1-.824.426.849.849,0,0,1-.774-.483,2.169,2.169,0,0,1-.289-1.165,3.142,3.142,0,0,1,.114-.829,2.777,2.777,0,0,1,.575-1.121,1.165,1.165,0,0,1,.871-.463.832.832,0,0,1,.366.083,1.192,1.192,0,0,1,.565.706.226.226,0,0,1,.023.1.209.209,0,0,1-.208.207.219.219,0,0,1-.065-.01.2.2,0,0,1-.133-.13l-.01-.019a1.007,1.007,0,0,0-.117-.229.553.553,0,0,0-.463-.276.54.54,0,0,0-.319.117,1.714,1.714,0,0,0-.528.759,2.846,2.846,0,0,0-.229,1.091,1.957,1.957,0,0,0,.166.857.562.562,0,0,0,.505.379.689.689,0,0,0,.467-.282,2.569,2.569,0,0,0,.5-.9c-.445,0-.677,0-.694-.008q-.227-.036-.231-.234a.2.2,0,0,1,.021-.07A.219.219,0,0,1,63.222,147.455Z",
    fill: "#fafafa"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3279",
    "data-name": "Group 3279"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3278",
    "data-name": "Group 3278"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3277",
    "data-name": "Group 3277"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3276",
    "data-name": "Group 3276"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1850",
    "data-name": "Path 1850",
    d: "M66.513,145.567c.008.019.017.043.026.071q.062.213.682,3.591a.158.158,0,0,1,.009.052.218.218,0,0,1-.028.106.191.191,0,0,1-.173.106.194.194,0,0,1-.033,0,.189.189,0,0,1-.16-.143l-.231-1.193h-1.19l-.573,1.2a.242.242,0,0,1-.019.04.228.228,0,0,1-.179.1.209.209,0,0,1-.113-.033.2.2,0,0,1-.1-.175.157.157,0,0,1,.013-.062c.036-.083.1-.215.177-.393q1.251-2.73,1.5-3.221a.226.226,0,0,1,.2-.146A.222.222,0,0,1,66.513,145.567Zm-.26.8-.644,1.355h.909Z",
    fill: "#fafafa"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3283",
    "data-name": "Group 3283"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3282",
    "data-name": "Group 3282"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3281",
    "data-name": "Group 3281"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3280",
    "data-name": "Group 3280"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1851",
    "data-name": "Path 1851",
    d: "M69.745,149.493H68a.206.206,0,0,1-.112-.033.317.317,0,0,1-.1-.219v0q0-.106.482-3.577a.608.608,0,0,1,.01-.076.192.192,0,0,1,.188-.128.2.2,0,0,1,.1.024.193.193,0,0,1,.11.184q-.023.237-.119.981-.3,2.289-.313,2.417h1.485a.3.3,0,0,1,.112.021.2.2,0,0,1,.132.195.229.229,0,0,1-.01.068A.244.244,0,0,1,69.745,149.493Z",
    fill: "#fafafa"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3287",
    "data-name": "Group 3287"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3286",
    "data-name": "Group 3286"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3285",
    "data-name": "Group 3285"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3284",
    "data-name": "Group 3284"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1852",
    "data-name": "Path 1852",
    d: "M72.134,145.567c.008.019.017.043.026.071q.061.213.682,3.591a.137.137,0,0,1,.01.052.209.209,0,0,1-.029.106.19.19,0,0,1-.173.106.194.194,0,0,1-.033,0,.189.189,0,0,1-.16-.143l-.231-1.193h-1.19l-.572,1.2a.361.361,0,0,1-.019.04.232.232,0,0,1-.18.1.209.209,0,0,1-.113-.033.2.2,0,0,1-.1-.175.177.177,0,0,1,.013-.062c.036-.083.1-.215.178-.393q1.25-2.73,1.494-3.221a.226.226,0,0,1,.2-.146A.221.221,0,0,1,72.134,145.567Zm-.26.8-.644,1.355h.909Z",
    fill: "#fafafa"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3291",
    "data-name": "Group 3291"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3290",
    "data-name": "Group 3290"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3289",
    "data-name": "Group 3289"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3288",
    "data-name": "Group 3288"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1853",
    "data-name": "Path 1853",
    d: "M74.917,147.629c.136.378.242.669.316.875.18.5.27.76.27.788a.181.181,0,0,1-.034.106.194.194,0,0,1-.174.1.189.189,0,0,1-.173-.14c-.013-.037-.024-.067-.033-.088q-.142-.327-.467-1.232l-.988,1.351a.241.241,0,0,1-.185.109.218.218,0,0,1-.108-.028.192.192,0,0,1-.1-.175.284.284,0,0,1,0-.044.508.508,0,0,1,.1-.168q.5-.644,1.1-1.53c-.042-.116-.082-.226-.121-.33q-.556-1.494-.557-1.544a.235.235,0,0,1,.026-.107.183.183,0,0,1,.169-.1.211.211,0,0,1,.195.116l.583,1.572,1.165-1.586a.236.236,0,0,1,.186-.1.205.205,0,0,1,.1.023.2.2,0,0,1,.1.186.28.28,0,0,1-.02.1Z",
    fill: "#fafafa"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3295",
    "data-name": "Group 3295"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3294",
    "data-name": "Group 3294"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3293",
    "data-name": "Group 3293"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3292",
    "data-name": "Group 3292"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1854",
    "data-name": "Path 1854",
    d: "M79.24,145.477a.207.207,0,0,1,.208.2q-.429,3.389-.473,3.661a2.239,2.239,0,0,1-.374.954,1.346,1.346,0,0,1-1.719.421,1.234,1.234,0,0,1-.616-.541.215.215,0,0,1-.024-.1.207.207,0,0,1,.029-.1.2.2,0,0,1,.179-.1.2.2,0,0,1,.159.086,1.123,1.123,0,0,0,.895.51.889.889,0,0,0,.694-.353,1.93,1.93,0,0,0,.385-1.1,1.054,1.054,0,0,1-.885.478.785.785,0,0,1-.117-.008.935.935,0,0,1-.663-.476,2.157,2.157,0,0,1-.291-1.164q0-.318.029-.655.05-.531.236-1.506a.262.262,0,0,1,.019-.06.19.19,0,0,1,.187-.142.2.2,0,0,1,.1.028.183.183,0,0,1,.1.166,7.594,7.594,0,0,1-.1.8,10.943,10.943,0,0,0-.138,1.218,2.437,2.437,0,0,0,.156.947c.12.284.292.426.518.426a.294.294,0,0,0,.07-.008.946.946,0,0,0,.522-.418,2.589,2.589,0,0,0,.432-.963l.265-1.991a.264.264,0,0,1,.026-.088A.191.191,0,0,1,79.24,145.477Z",
    fill: "#fafafa"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3302",
    "data-name": "Group 3302"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3301",
    "data-name": "Group 3301"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3300",
    "data-name": "Group 3300"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3299",
    "data-name": "Group 3299"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3298",
    "data-name": "Group 3298"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3297",
    "data-name": "Group 3297"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1855",
    "data-name": "Path 1855",
    d: "M105.3,152.776c-.059,0-.107-2.385-.107-5.327s.048-5.327.107-5.327.107,2.384.107,5.327S105.362,152.776,105.3,152.776Z",
    fill: "#f5f5f5"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3308",
    "data-name": "Group 3308"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3307",
    "data-name": "Group 3307"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3306",
    "data-name": "Group 3306"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3305",
    "data-name": "Group 3305"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3304",
    "data-name": "Group 3304"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3303",
    "data-name": "Group 3303"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1856",
    "data-name": "Path 1856",
    d: "M57.874,152.776c-.06,0-.107-2.385-.107-5.327s.047-5.327.107-5.327.107,2.384.107,5.327S57.933,152.776,57.874,152.776Z",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3314",
    "data-name": "Group 3314"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3313",
    "data-name": "Group 3313"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3312",
    "data-name": "Group 3312"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3311",
    "data-name": "Group 3311"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3310",
    "data-name": "Group 3310"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3309",
    "data-name": "Group 3309"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1857",
    "data-name": "Path 1857",
    d: "M106.32,152.776c-.06,0-.107-2.385-.107-5.327s.047-5.327.107-5.327.107,2.384.107,5.327S106.379,152.776,106.32,152.776Z",
    fill: "#f5f5f5"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3320",
    "data-name": "Group 3320"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3319",
    "data-name": "Group 3319"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3318",
    "data-name": "Group 3318"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3317",
    "data-name": "Group 3317"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3316",
    "data-name": "Group 3316"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3315",
    "data-name": "Group 3315"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1858",
    "data-name": "Path 1858",
    d: "M56.923,152.776c-.059,0-.107-2.385-.107-5.327s.048-5.327.107-5.327.107,2.384.107,5.327S56.982,152.776,56.923,152.776Z",
    fill: "#e0e0e0"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3383",
    "data-name": "Group 3383"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3331",
    "data-name": "Group 3331"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3330",
    "data-name": "Group 3330"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3329",
    "data-name": "Group 3329"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3328",
    "data-name": "Group 3328"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3327",
    "data-name": "Group 3327"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3326",
    "data-name": "Group 3326"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3325",
    "data-name": "Group 3325"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3324",
    "data-name": "Group 3324"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3323",
    "data-name": "Group 3323"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3322",
    "data-name": "Group 3322"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1859",
    "data-name": "Path 1859",
    d: "M91.249,143.877l-.009-.019c1.582,1.277,3.733,3.013,6.126,4.942l.054.044-.068.018-.815.214-5.172,1.358-.01,0-.01,0-4.688-1.988-1.326-.568-.351-.153-.089-.041-.03-.015a.145.145,0,0,1,.032.011l.091.035.354.144,1.334.552,4.7,1.965-.021,0,5.17-1.364.816-.214-.014.061L91.208,143.9l-.009-.007v-.011",
    fill: "#e0e0e0"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3340",
    "data-name": "Group 3340"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3339",
    "data-name": "Group 3339"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3338",
    "data-name": "Group 3338"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3337",
    "data-name": "Group 3337"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3336",
    "data-name": "Group 3336"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3335",
    "data-name": "Group 3335"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3334",
    "data-name": "Group 3334"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3333",
    "data-name": "Group 3333"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3332",
    "data-name": "Group 3332"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1860",
    "data-name": "Path 1860",
    d: "M96.812,148.031l.334.314.448-.1-.2.415.231.4L97.174,149l-.306.342-.085-.451-.42-.185.4-.22Z",
    fill: "#e0e0e0"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3349",
    "data-name": "Group 3349"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3348",
    "data-name": "Group 3348"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3347",
    "data-name": "Group 3347"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3346",
    "data-name": "Group 3346"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3345",
    "data-name": "Group 3345"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3344",
    "data-name": "Group 3344"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3343",
    "data-name": "Group 3343"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3342",
    "data-name": "Group 3342"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3341",
    "data-name": "Group 3341"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1861",
    "data-name": "Path 1861",
    d: "M90.936,149.979l.228.19.286-.08-.11.276.165.247-.3-.019-.184.233-.073-.288-.279-.1.251-.158Z",
    fill: "#e0e0e0"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3358",
    "data-name": "Group 3358"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3357",
    "data-name": "Group 3357"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3356",
    "data-name": "Group 3356"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3355",
    "data-name": "Group 3355"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3354",
    "data-name": "Group 3354"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3353",
    "data-name": "Group 3353"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3352",
    "data-name": "Group 3352"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3351",
    "data-name": "Group 3351"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3350",
    "data-name": "Group 3350"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1862",
    "data-name": "Path 1862",
    d: "M84.445,147.316l.364.023.225-.287.091.353.342.125-.308.2-.014.364-.281-.232-.35.1.134-.339Z",
    fill: "#e0e0e0"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3367",
    "data-name": "Group 3367"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3366",
    "data-name": "Group 3366"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3365",
    "data-name": "Group 3365"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3364",
    "data-name": "Group 3364"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3363",
    "data-name": "Group 3363"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3362",
    "data-name": "Group 3362"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3361",
    "data-name": "Group 3361"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3360",
    "data-name": "Group 3360"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3359",
    "data-name": "Group 3359"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1863",
    "data-name": "Path 1863",
    d: "M99.558,143.954l.364.023.225-.287.091.353.342.125-.307.2-.014.364-.281-.232-.35.1.134-.339Z",
    fill: "#e0e0e0"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3376",
    "data-name": "Group 3376"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3375",
    "data-name": "Group 3375"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3374",
    "data-name": "Group 3374"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3373",
    "data-name": "Group 3373"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3372",
    "data-name": "Group 3372"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3371",
    "data-name": "Group 3371"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3370",
    "data-name": "Group 3370"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3369",
    "data-name": "Group 3369"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3368",
    "data-name": "Group 3368"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1864",
    "data-name": "Path 1864",
    d: "M90.952,143.715l.232.015.144-.183.058.225.218.08-.2.125-.009.232-.179-.148-.224.064.086-.216Z",
    fill: "#e0e0e0"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3382",
    "data-name": "Group 3382"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3381",
    "data-name": "Group 3381"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3380",
    "data-name": "Group 3380"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3379",
    "data-name": "Group 3379"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3378",
    "data-name": "Group 3378"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3377",
    "data-name": "Group 3377"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1865",
    "data-name": "Path 1865",
    d: "M100.069,144.209c0,.024-1.983-.042-4.426-.146s-4.423-.209-4.422-.232,1.982.042,4.426.146S100.07,144.186,100.069,144.209Z",
    fill: "#e0e0e0"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3419",
    "data-name": "Group 3419"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3389",
    "data-name": "Group 3389"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3388",
    "data-name": "Group 3388"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3387",
    "data-name": "Group 3387"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3386",
    "data-name": "Group 3386"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3385",
    "data-name": "Group 3385"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1866",
    "data-name": "Path 1866",
    d: "M102.295,142.166H43.511c-.77-1.747-.958-3.406,0-4.893h58.784A5.671,5.671,0,0,1,102.295,142.166Z",
    fill: "#e0e0e0"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3394",
    "data-name": "Group 3394"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3393",
    "data-name": "Group 3393"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3392",
    "data-name": "Group 3392"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3391",
    "data-name": "Group 3391"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3390",
    "data-name": "Group 3390"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_221",
    "data-name": "Rectangle 221",
    width: 31.847,
    height: 1.781,
    transform: "translate(55.683 138.672)",
    fill: "#ebebeb"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3400",
    "data-name": "Group 3400"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3399",
    "data-name": "Group 3399"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3398",
    "data-name": "Group 3398"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3397",
    "data-name": "Group 3397"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3396",
    "data-name": "Group 3396"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3395",
    "data-name": "Group 3395"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1867",
    "data-name": "Path 1867",
    d: "M45.767,142.193a1.731,1.731,0,0,1-.464-.592,4.323,4.323,0,0,1-.311-3.54,1.721,1.721,0,0,1,.354-.664,5.8,5.8,0,0,1-.21.709,4.959,4.959,0,0,0,.3,3.426A5.351,5.351,0,0,1,45.767,142.193Z",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3406",
    "data-name": "Group 3406"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3405",
    "data-name": "Group 3405"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3404",
    "data-name": "Group 3404"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3403",
    "data-name": "Group 3403"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3402",
    "data-name": "Group 3402"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3401",
    "data-name": "Group 3401"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1868",
    "data-name": "Path 1868",
    d: "M47.039,142.193a1.731,1.731,0,0,1-.464-.592,4.323,4.323,0,0,1-.311-3.54,1.721,1.721,0,0,1,.354-.664,5.8,5.8,0,0,1-.21.709,4.959,4.959,0,0,0,.3,3.426A5.352,5.352,0,0,1,47.039,142.193Z",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3412",
    "data-name": "Group 3412"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3411",
    "data-name": "Group 3411"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3410",
    "data-name": "Group 3410"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3409",
    "data-name": "Group 3409"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3408",
    "data-name": "Group 3408"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3407",
    "data-name": "Group 3407"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1869",
    "data-name": "Path 1869",
    d: "M99.916,142.079a7.37,7.37,0,0,0,.028-4.79,4.978,4.978,0,0,1-.028,4.79Z",
    fill: "#f5f5f5"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3418",
    "data-name": "Group 3418"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3417",
    "data-name": "Group 3417"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3416",
    "data-name": "Group 3416"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3415",
    "data-name": "Group 3415"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3414",
    "data-name": "Group 3414"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3413",
    "data-name": "Group 3413"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1870",
    "data-name": "Path 1870",
    d: "M98.822,142.067c-.064-.015.184-1.048.177-2.343s-.247-2.327-.183-2.343a7.164,7.164,0,0,1,.006,4.686Z",
    fill: "#f5f5f5"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3461",
    "data-name": "Group 3461"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3440",
    "data-name": "Group 3440"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3426",
    "data-name": "Group 3426"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3425",
    "data-name": "Group 3425"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3424",
    "data-name": "Group 3424"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3423",
    "data-name": "Group 3423"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3422",
    "data-name": "Group 3422"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3421",
    "data-name": "Group 3421"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_222",
    "data-name": "Rectangle 222",
    width: 20.931,
    height: 22.203,
    transform: "translate(129.98 69.392) rotate(-0.306)",
    fill: "#ebebeb"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3432",
    "data-name": "Group 3432"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3431",
    "data-name": "Group 3431"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3430",
    "data-name": "Group 3430"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3429",
    "data-name": "Group 3429"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3428",
    "data-name": "Group 3428"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3427",
    "data-name": "Group 3427"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_223",
    "data-name": "Rectangle 223",
    width: 20.931,
    height: 22.204,
    transform: "translate(150.811 69.28) rotate(-0.307)",
    fill: "#f5f5f5"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3439",
    "data-name": "Group 3439"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3438",
    "data-name": "Group 3438"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3437",
    "data-name": "Group 3437"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3436",
    "data-name": "Group 3436"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3435",
    "data-name": "Group 3435"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3434",
    "data-name": "Group 3434"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3433",
    "data-name": "Group 3433"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1871",
    "data-name": "Path 1871",
    d: "M130.012,75.524q20.865.172,41.763-.193a.222.222,0,0,0,0-.444q-20.865-.116-41.762.255a.191.191,0,0,0,0,.382Z",
    fill: "#e0e0e0"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3460",
    "data-name": "Group 3460"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3446",
    "data-name": "Group 3446"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3445",
    "data-name": "Group 3445"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3444",
    "data-name": "Group 3444"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3443",
    "data-name": "Group 3443"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3442",
    "data-name": "Group 3442"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3441",
    "data-name": "Group 3441"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_224",
    "data-name": "Rectangle 224",
    width: 38.028,
    height: 18.094,
    transform: "translate(116.93 91.316) rotate(-0.307)",
    fill: "#ebebeb"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3452",
    "data-name": "Group 3452"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3451",
    "data-name": "Group 3451"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3450",
    "data-name": "Group 3450"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3449",
    "data-name": "Group 3449"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3448",
    "data-name": "Group 3448"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3447",
    "data-name": "Group 3447"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_225",
    "data-name": "Rectangle 225",
    width: 38.028,
    height: 18.094,
    transform: "translate(154.777 91.113) rotate(-0.307)",
    fill: "#f5f5f5"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3459",
    "data-name": "Group 3459"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3458",
    "data-name": "Group 3458"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3457",
    "data-name": "Group 3457"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3456",
    "data-name": "Group 3456"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3455",
    "data-name": "Group 3455"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3454",
    "data-name": "Group 3454"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3453",
    "data-name": "Group 3453"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1872",
    "data-name": "Path 1872",
    d: "M116.956,96.348c25.263.286,50.615.03,75.876-.374a.223.223,0,0,0,0-.445c-25.265-.134-50.617-.119-75.876.438a.191.191,0,0,0,0,.381Z",
    fill: "#e0e0e0"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3482",
    "data-name": "Group 3482"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3481",
    "data-name": "Group 3481"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3467",
    "data-name": "Group 3467"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3466",
    "data-name": "Group 3466"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3465",
    "data-name": "Group 3465"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3464",
    "data-name": "Group 3464"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3463",
    "data-name": "Group 3463"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3462",
    "data-name": "Group 3462"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_226",
    "data-name": "Rectangle 226",
    width: 38.028,
    height: 18.094,
    transform: "translate(82.604 193.729) rotate(-0.307)",
    fill: "#ebebeb"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3473",
    "data-name": "Group 3473"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3472",
    "data-name": "Group 3472"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3471",
    "data-name": "Group 3471"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3470",
    "data-name": "Group 3470"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3469",
    "data-name": "Group 3469"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3468",
    "data-name": "Group 3468"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_227",
    "data-name": "Rectangle 227",
    width: 38.028,
    height: 18.094,
    transform: "translate(120.451 193.527) rotate(-0.307)",
    fill: "#f5f5f5"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3480",
    "data-name": "Group 3480"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3479",
    "data-name": "Group 3479"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3478",
    "data-name": "Group 3478"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3477",
    "data-name": "Group 3477"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3476",
    "data-name": "Group 3476"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3475",
    "data-name": "Group 3475"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3474",
    "data-name": "Group 3474"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1873",
    "data-name": "Path 1873",
    d: "M82.63,198.762c25.263.286,50.615.029,75.876-.375a.223.223,0,0,0,0-.445c-25.265-.133-50.617-.118-75.876.438a.191.191,0,0,0,0,.382Z",
    fill: "#e0e0e0"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3548",
    "data-name": "Group 3548"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3488",
    "data-name": "Group 3488"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3487",
    "data-name": "Group 3487"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3486",
    "data-name": "Group 3486"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3485",
    "data-name": "Group 3485"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3484",
    "data-name": "Group 3484"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3483",
    "data-name": "Group 3483"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_228",
    "data-name": "Rectangle 228",
    width: 9.593,
    height: 47.733,
    transform: "matrix(1, -0.005, 0.005, 1, 59.997, 61.777)",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3494",
    "data-name": "Group 3494"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3493",
    "data-name": "Group 3493"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3492",
    "data-name": "Group 3492"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3491",
    "data-name": "Group 3491"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3490",
    "data-name": "Group 3490"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3489",
    "data-name": "Group 3489"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_229",
    "data-name": "Rectangle 229",
    width: 9.593,
    height: 65.65,
    transform: "translate(69.357 43.977) rotate(-0.308)",
    fill: "#ebebeb"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3531",
    "data-name": "Group 3531"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3500",
    "data-name": "Group 3500"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3499",
    "data-name": "Group 3499"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3498",
    "data-name": "Group 3498"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3497",
    "data-name": "Group 3497"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3496",
    "data-name": "Group 3496"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3495",
    "data-name": "Group 3495"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_230",
    "data-name": "Rectangle 230",
    width: 14.906,
    height: 53.202,
    transform: "translate(79.033 56.226) rotate(-0.308)",
    fill: "#f5f5f5"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3506",
    "data-name": "Group 3506"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3505",
    "data-name": "Group 3505"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3504",
    "data-name": "Group 3504"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3503",
    "data-name": "Group 3503"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3502",
    "data-name": "Group 3502"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3501",
    "data-name": "Group 3501"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1874",
    "data-name": "Path 1874",
    d: "M93.838,66.4a53.948,53.948,0,0,1-7.452.258,53.945,53.945,0,0,1-7.453-.258,53.943,53.943,0,0,1,7.453-.258A53.946,53.946,0,0,1,93.838,66.4Z",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3512",
    "data-name": "Group 3512"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3511",
    "data-name": "Group 3511"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3510",
    "data-name": "Group 3510"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3509",
    "data-name": "Group 3509"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3508",
    "data-name": "Group 3508"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3507",
    "data-name": "Group 3507"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1875",
    "data-name": "Path 1875",
    d: "M93.838,64.161a54.137,54.137,0,0,1-7.452.258,54.134,54.134,0,0,1-7.453-.258,53.943,53.943,0,0,1,7.453-.258A53.946,53.946,0,0,1,93.838,64.161Z",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3518",
    "data-name": "Group 3518"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3517",
    "data-name": "Group 3517"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3516",
    "data-name": "Group 3516"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3515",
    "data-name": "Group 3515"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3514",
    "data-name": "Group 3514"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3513",
    "data-name": "Group 3513"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1876",
    "data-name": "Path 1876",
    d: "M93.838,101.343a53.948,53.948,0,0,1-7.452.258,53.945,53.945,0,0,1-7.453-.258,53.943,53.943,0,0,1,7.453-.258A53.946,53.946,0,0,1,93.838,101.343Z",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3524",
    "data-name": "Group 3524"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3523",
    "data-name": "Group 3523"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3522",
    "data-name": "Group 3522"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3521",
    "data-name": "Group 3521"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3520",
    "data-name": "Group 3520"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3519",
    "data-name": "Group 3519"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1877",
    "data-name": "Path 1877",
    d: "M93.838,99.108a53.948,53.948,0,0,1-7.452.258,53.945,53.945,0,0,1-7.453-.258,54.133,54.133,0,0,1,7.453-.258A54.136,54.136,0,0,1,93.838,99.108Z",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3530",
    "data-name": "Group 3530"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3529",
    "data-name": "Group 3529"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3528",
    "data-name": "Group 3528"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3527",
    "data-name": "Group 3527"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3526",
    "data-name": "Group 3526"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3525",
    "data-name": "Group 3525"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1878",
    "data-name": "Path 1878",
    d: "M86.626,94.232c-.143,0-.259-5.368-.259-11.987s.116-11.989.259-11.989.258,5.367.258,11.989S86.768,94.232,86.626,94.232Z",
    fill: "#e0e0e0"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3537",
    "data-name": "Group 3537"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3536",
    "data-name": "Group 3536"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3535",
    "data-name": "Group 3535"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3534",
    "data-name": "Group 3534"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3533",
    "data-name": "Group 3533"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3532",
    "data-name": "Group 3532"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_231",
    "data-name": "Rectangle 231",
    width: 16.225,
    height: 40.157,
    transform: "translate(94 69.211)",
    fill: "#ebebeb"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3542",
    "data-name": "Group 3542"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3541",
    "data-name": "Group 3541"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3540",
    "data-name": "Group 3540"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3539",
    "data-name": "Group 3539"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3538",
    "data-name": "Group 3538"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1879",
    "data-name": "Path 1879",
    d: "M76.77,55.134a2.757,2.757,0,1,1-2.758-2.757A2.757,2.757,0,0,1,76.77,55.134Z",
    fill: "#e0e0e0"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3547",
    "data-name": "Group 3547"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3546",
    "data-name": "Group 3546"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3545",
    "data-name": "Group 3545"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3544",
    "data-name": "Group 3544"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3543",
    "data-name": "Group 3543"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_232",
    "data-name": "Rectangle 232",
    width: 1.704,
    height: 39.054,
    transform: "translate(73.16 62.717)",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3554",
    "data-name": "Group 3554"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3549",
    "data-name": "Group 3549"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_233",
    "data-name": "Rectangle 233",
    width: 168.89,
    height: 5.775,
    transform: "translate(33.27 164.43)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3550",
    "data-name": "Group 3550"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_234",
    "data-name": "Rectangle 234",
    width: 168.89,
    height: 5.775,
    transform: "translate(33.27 109.626)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3551",
    "data-name": "Group 3551"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_235",
    "data-name": "Rectangle 235",
    width: 134.421,
    height: 5.451,
    transform: "translate(67.738 211.853)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3552",
    "data-name": "Group 3552"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_236",
    "data-name": "Rectangle 236",
    width: 6.441,
    height: 54.516,
    transform: "translate(111.273 114.273)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3553",
    "data-name": "Group 3553"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_237",
    "data-name": "Rectangle 237",
    width: 6.441,
    height: 52.854,
    transform: "translate(67.775 164.43)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3556",
    "data-name": "Group 3556"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3555",
    "data-name": "Group 3555"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1880",
    "data-name": "Path 1880",
    d: "M149.96,139.645,146,145.336s8.908,2.475,8.908,10.393-5.444,9.4-11.383,9.4-11.629-1.732-11.382-9.65,7.671-10.887,7.671-10.887l-3.712-4.949Z",
    fill: "#f5f5f5"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3689",
    "data-name": "Group 3689"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3627",
    "data-name": "Group 3627"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3626",
    "data-name": "Group 3626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3562",
    "data-name": "Group 3562"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3561",
    "data-name": "Group 3561"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3560",
    "data-name": "Group 3560"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3559",
    "data-name": "Group 3559"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3558",
    "data-name": "Group 3558"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_238",
    "data-name": "Rectangle 238",
    width: 178.781,
    height: 82.451,
    transform: "translate(239.687 343.379)",
    fill: "#f5f5f5"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3567",
    "data-name": "Group 3567"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3566",
    "data-name": "Group 3566"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3565",
    "data-name": "Group 3565"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3564",
    "data-name": "Group 3564"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3563",
    "data-name": "Group 3563"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1881",
    "data-name": "Path 1881",
    d: "M414.212,421.944H243.778V347.717H414.212Zm-169.321-1.112H413.1v-72H244.891Z",
    fill: "#e0e0e0"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3572",
    "data-name": "Group 3572"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3571",
    "data-name": "Group 3571"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3570",
    "data-name": "Group 3570"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3569",
    "data-name": "Group 3569"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3568",
    "data-name": "Group 3568"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_239",
    "data-name": "Rectangle 239",
    width: 43.675,
    height: 82.451,
    transform: "translate(418.467 343.379)",
    fill: "#e0e0e0"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3578",
    "data-name": "Group 3578"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3577",
    "data-name": "Group 3577"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3576",
    "data-name": "Group 3576"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3575",
    "data-name": "Group 3575"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3574",
    "data-name": "Group 3574"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3573",
    "data-name": "Group 3573"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1882",
    "data-name": "Path 1882",
    d: "M244.335,370.689H413.656a.225.225,0,0,0,0-.449H244.335a.225.225,0,0,0,0,.449Z",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3584",
    "data-name": "Group 3584"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3583",
    "data-name": "Group 3583"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3582",
    "data-name": "Group 3582"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3581",
    "data-name": "Group 3581"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3580",
    "data-name": "Group 3580"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3579",
    "data-name": "Group 3579"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1883",
    "data-name": "Path 1883",
    d: "M329.548,370.464a185.318,185.318,0,0,0,.058-22.4.228.228,0,0,0-.456,0,185.325,185.325,0,0,0,.058,22.4.17.17,0,0,0,.34,0Z",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3589",
    "data-name": "Group 3589"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3588",
    "data-name": "Group 3588"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3587",
    "data-name": "Group 3587"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3586",
    "data-name": "Group 3586"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3585",
    "data-name": "Group 3585"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1884",
    "data-name": "Path 1884",
    d: "M375.124,359.266a2.307,2.307,0,1,1-2.307-2.307A2.307,2.307,0,0,1,375.124,359.266Z",
    fill: "#e0e0e0"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3594",
    "data-name": "Group 3594"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3593",
    "data-name": "Group 3593"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3592",
    "data-name": "Group 3592"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3591",
    "data-name": "Group 3591"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3590",
    "data-name": "Group 3590"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1885",
    "data-name": "Path 1885",
    d: "M286.263,359.266a2.307,2.307,0,1,1-2.306-2.307A2.306,2.306,0,0,1,286.263,359.266Z",
    fill: "#e0e0e0"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3599",
    "data-name": "Group 3599"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3598",
    "data-name": "Group 3598"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3597",
    "data-name": "Group 3597"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3596",
    "data-name": "Group 3596"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3595",
    "data-name": "Group 3595"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1886",
    "data-name": "Path 1886",
    d: "M331.3,384.831a2.307,2.307,0,1,1-2.307-2.307A2.307,2.307,0,0,1,331.3,384.831Z",
    fill: "#e0e0e0"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3604",
    "data-name": "Group 3604"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3603",
    "data-name": "Group 3603"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3602",
    "data-name": "Group 3602"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3601",
    "data-name": "Group 3601"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3600",
    "data-name": "Group 3600"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1887",
    "data-name": "Path 1887",
    d: "M261.062,425.83l-9.2,51.765h5.177l16.971-51.765Z",
    fill: "#e0e0e0"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3609",
    "data-name": "Group 3609"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3608",
    "data-name": "Group 3608"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3607",
    "data-name": "Group 3607"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3606",
    "data-name": "Group 3606"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3605",
    "data-name": "Group 3605"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1888",
    "data-name": "Path 1888",
    d: "M405.818,425.83l7.7,51.855h-5.177L392.875,425.83Z",
    fill: "#e0e0e0"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3614",
    "data-name": "Group 3614"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3613",
    "data-name": "Group 3613"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3612",
    "data-name": "Group 3612"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3611",
    "data-name": "Group 3611"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3610",
    "data-name": "Group 3610"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1889",
    "data-name": "Path 1889",
    d: "M440.38,425.83l8.721,51.855h-5.177L427.436,425.83Z",
    fill: "#e0e0e0"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3619",
    "data-name": "Group 3619"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3618",
    "data-name": "Group 3618"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3617",
    "data-name": "Group 3617"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3616",
    "data-name": "Group 3616"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3615",
    "data-name": "Group 3615"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1890",
    "data-name": "Path 1890",
    d: "M331.147,408.166a2.307,2.307,0,1,1-2.306-2.307A2.306,2.306,0,0,1,331.147,408.166Z",
    fill: "#e0e0e0"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3625",
    "data-name": "Group 3625"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3624",
    "data-name": "Group 3624"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3623",
    "data-name": "Group 3623"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3622",
    "data-name": "Group 3622"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3621",
    "data-name": "Group 3621"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3620",
    "data-name": "Group 3620"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1891",
    "data-name": "Path 1891",
    d: "M244.335,396.221H413.656a.225.225,0,0,0,0-.449H244.335a.225.225,0,0,0,0,.449Z",
    fill: "#e0e0e0"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3688",
    "data-name": "Group 3688"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3633",
    "data-name": "Group 3633"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3632",
    "data-name": "Group 3632"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3631",
    "data-name": "Group 3631"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3630",
    "data-name": "Group 3630"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3629",
    "data-name": "Group 3629"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3628",
    "data-name": "Group 3628"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_240",
    "data-name": "Rectangle 240",
    width: 11.004,
    height: 54.055,
    transform: "translate(364.451 304.392) rotate(89.697)",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3670",
    "data-name": "Group 3670"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3639",
    "data-name": "Group 3639"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3638",
    "data-name": "Group 3638"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3637",
    "data-name": "Group 3637"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3636",
    "data-name": "Group 3636"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3635",
    "data-name": "Group 3635"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3634",
    "data-name": "Group 3634"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_241",
    "data-name": "Rectangle 241",
    width: 17.098,
    height: 60.248,
    transform: "translate(370.913 326.052) rotate(89.697)",
    fill: "#f5f5f5"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3645",
    "data-name": "Group 3645"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3644",
    "data-name": "Group 3644"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3643",
    "data-name": "Group 3643"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3642",
    "data-name": "Group 3642"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3641",
    "data-name": "Group 3641"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3640",
    "data-name": "Group 3640"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1892",
    "data-name": "Path 1892",
    d: "M359.4,343.031a62.885,62.885,0,0,1-.292-8.549,62.882,62.882,0,0,1,.292-8.55,62.58,62.58,0,0,1,.293,8.55A62.584,62.584,0,0,1,359.4,343.031Z",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3651",
    "data-name": "Group 3651"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3650",
    "data-name": "Group 3650"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3649",
    "data-name": "Group 3649"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3648",
    "data-name": "Group 3648"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3647",
    "data-name": "Group 3647"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3646",
    "data-name": "Group 3646"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1893",
    "data-name": "Path 1893",
    d: "M361.927,343.031a62.885,62.885,0,0,1-.292-8.549,62.882,62.882,0,0,1,.292-8.55,62.586,62.586,0,0,1,.293,8.55A62.589,62.589,0,0,1,361.927,343.031Z",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3657",
    "data-name": "Group 3657"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3656",
    "data-name": "Group 3656"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3655",
    "data-name": "Group 3655"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3654",
    "data-name": "Group 3654"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3653",
    "data-name": "Group 3653"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3652",
    "data-name": "Group 3652"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1894",
    "data-name": "Path 1894",
    d: "M319.82,343.031a62.885,62.885,0,0,1-.292-8.549,62.882,62.882,0,0,1,.292-8.55,62.586,62.586,0,0,1,.293,8.55A62.589,62.589,0,0,1,319.82,343.031Z",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3663",
    "data-name": "Group 3663"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3662",
    "data-name": "Group 3662"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3661",
    "data-name": "Group 3661"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3660",
    "data-name": "Group 3660"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3659",
    "data-name": "Group 3659"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3658",
    "data-name": "Group 3658"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1895",
    "data-name": "Path 1895",
    d: "M322.352,343.031a62.589,62.589,0,0,1-.293-8.549,62.586,62.586,0,0,1,.293-8.55,62.879,62.879,0,0,1,.292,8.55A62.882,62.882,0,0,1,322.352,343.031Z",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3669",
    "data-name": "Group 3669"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3668",
    "data-name": "Group 3668"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3667",
    "data-name": "Group 3667"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3666",
    "data-name": "Group 3666"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3665",
    "data-name": "Group 3665"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3664",
    "data-name": "Group 3664"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1896",
    "data-name": "Path 1896",
    d: "M327.874,334.757c0-.164,6.078-.3,13.574-.3s13.576.132,13.576.3-6.077.3-13.576.3S327.874,334.92,327.874,334.757Z",
    fill: "#e0e0e0"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3687",
    "data-name": "Group 3687"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3676",
    "data-name": "Group 3676"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3675",
    "data-name": "Group 3675"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3674",
    "data-name": "Group 3674"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3673",
    "data-name": "Group 3673"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3672",
    "data-name": "Group 3672"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3671",
    "data-name": "Group 3671"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_242",
    "data-name": "Rectangle 242",
    width: 11.004,
    height: 74.345,
    transform: "matrix(0.005, 1, -1, 0.005, 393.57, 314.95)",
    fill: "#ebebeb"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3681",
    "data-name": "Group 3681"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3680",
    "data-name": "Group 3680"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3679",
    "data-name": "Group 3679"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3678",
    "data-name": "Group 3678"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3677",
    "data-name": "Group 3677"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1897",
    "data-name": "Path 1897",
    d: "M382.983,324.588a3.559,3.559,0,1,1,3.514-3.559A3.536,3.536,0,0,1,382.983,324.588Z",
    fill: "#e0e0e0"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3686",
    "data-name": "Group 3686"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3685",
    "data-name": "Group 3685"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3684",
    "data-name": "Group 3684"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3683",
    "data-name": "Group 3683"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3682",
    "data-name": "Group 3682"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_243",
    "data-name": "Rectangle 243",
    width: 2.2,
    height: 49.765,
    transform: "translate(373.321 319.93) rotate(90)",
    fill: "#e0e0e0"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3774",
    "data-name": "Group 3774"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3697",
    "data-name": "Group 3697"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3696",
    "data-name": "Group 3696"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3695",
    "data-name": "Group 3695"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3694",
    "data-name": "Group 3694"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3693",
    "data-name": "Group 3693"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3692",
    "data-name": "Group 3692"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3691",
    "data-name": "Group 3691"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3690",
    "data-name": "Group 3690"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_244",
    "data-name": "Rectangle 244",
    width: 84.706,
    height: 88.299,
    transform: "translate(335.652 155.517)",
    fill: "#e0e0e0"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3712",
    "data-name": "Group 3712"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3704",
    "data-name": "Group 3704"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3703",
    "data-name": "Group 3703"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3702",
    "data-name": "Group 3702"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3701",
    "data-name": "Group 3701"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3700",
    "data-name": "Group 3700"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3699",
    "data-name": "Group 3699"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3698",
    "data-name": "Group 3698"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_245",
    "data-name": "Rectangle 245",
    width: 84.706,
    height: 88.299,
    transform: "translate(329.916 155.517)",
    fill: "#fafafa"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3711",
    "data-name": "Group 3711"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3710",
    "data-name": "Group 3710"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3709",
    "data-name": "Group 3709"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3708",
    "data-name": "Group 3708"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3707",
    "data-name": "Group 3707"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3706",
    "data-name": "Group 3706"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3705",
    "data-name": "Group 3705"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1898",
    "data-name": "Path 1898",
    d: "M414.648,243.843H329.889V155.491h84.759Zm-84.706-.053H414.6V155.544H329.942Z",
    fill: "#e0e0e0"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3720",
    "data-name": "Group 3720"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3719",
    "data-name": "Group 3719"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3718",
    "data-name": "Group 3718"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3717",
    "data-name": "Group 3717"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3716",
    "data-name": "Group 3716"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3715",
    "data-name": "Group 3715"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3714",
    "data-name": "Group 3714"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3713",
    "data-name": "Group 3713"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_246",
    "data-name": "Rectangle 246",
    width: 61.932,
    height: 64.559,
    transform: "translate(341.302 167.387)",
    fill: "#fff"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3729",
    "data-name": "Group 3729"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3728",
    "data-name": "Group 3728"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3727",
    "data-name": "Group 3727"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3726",
    "data-name": "Group 3726"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3725",
    "data-name": "Group 3725"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3724",
    "data-name": "Group 3724"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3723",
    "data-name": "Group 3723"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3722",
    "data-name": "Group 3722"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3721",
    "data-name": "Group 3721"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1899",
    "data-name": "Path 1899",
    d: "M341.3,232.376a10.1,10.1,0,0,1-1.528,1.777c-.989,1.044-2.379,2.456-3.937,3.991s-2.99,2.9-4.046,3.873a9.911,9.911,0,0,1-1.79,1.491,9.875,9.875,0,0,1,1.52-1.77c.989-1.044,2.383-2.46,3.946-4s3-2.909,4.053-3.88A9.759,9.759,0,0,1,341.3,232.376Z",
    fill: "#e0e0e0"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3738",
    "data-name": "Group 3738"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3737",
    "data-name": "Group 3737"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3736",
    "data-name": "Group 3736"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3735",
    "data-name": "Group 3735"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3734",
    "data-name": "Group 3734"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3733",
    "data-name": "Group 3733"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3732",
    "data-name": "Group 3732"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3731",
    "data-name": "Group 3731"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3730",
    "data-name": "Group 3730"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1900",
    "data-name": "Path 1900",
    d: "M403.235,232.218a10.1,10.1,0,0,1,1.777,1.528c1.044.989,2.456,2.379,3.991,3.936s2.9,2.991,3.873,4.047a9.911,9.911,0,0,1,1.491,1.79A9.927,9.927,0,0,1,412.6,242c-1.043-.99-2.46-2.383-4-3.946s-2.909-3-3.88-4.054A9.739,9.739,0,0,1,403.235,232.218Z",
    fill: "#e0e0e0"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3747",
    "data-name": "Group 3747"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3746",
    "data-name": "Group 3746"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3745",
    "data-name": "Group 3745"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3744",
    "data-name": "Group 3744"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3743",
    "data-name": "Group 3743"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3742",
    "data-name": "Group 3742"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3741",
    "data-name": "Group 3741"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3740",
    "data-name": "Group 3740"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3739",
    "data-name": "Group 3739"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1901",
    "data-name": "Path 1901",
    d: "M403.065,167.56a10.2,10.2,0,0,1,1.529-1.777c.989-1.044,2.379-2.457,3.937-3.991s2.99-2.9,4.046-3.873a9.8,9.8,0,0,1,1.79-1.491,9.906,9.906,0,0,1-1.52,1.769c-.99,1.044-2.383,2.46-3.946,4s-3,2.91-4.054,3.88A9.666,9.666,0,0,1,403.065,167.56Z",
    fill: "#e0e0e0"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3756",
    "data-name": "Group 3756"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3755",
    "data-name": "Group 3755"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3754",
    "data-name": "Group 3754"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3753",
    "data-name": "Group 3753"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3752",
    "data-name": "Group 3752"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3751",
    "data-name": "Group 3751"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3750",
    "data-name": "Group 3750"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3749",
    "data-name": "Group 3749"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3748",
    "data-name": "Group 3748"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1902",
    "data-name": "Path 1902",
    d: "M341.133,167.718a10.1,10.1,0,0,1-1.777-1.528c-1.044-.989-2.456-2.379-3.991-3.937s-2.9-2.99-3.873-4.046a9.8,9.8,0,0,1-1.491-1.79,9.875,9.875,0,0,1,1.77,1.52c1.043.989,2.459,2.383,4,3.946s2.909,3,3.879,4.054A9.644,9.644,0,0,1,341.133,167.718Z",
    fill: "#e0e0e0"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3765",
    "data-name": "Group 3765"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3764",
    "data-name": "Group 3764"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3763",
    "data-name": "Group 3763"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3762",
    "data-name": "Group 3762"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3761",
    "data-name": "Group 3761"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3760",
    "data-name": "Group 3760"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3759",
    "data-name": "Group 3759"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3758",
    "data-name": "Group 3758"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3757",
    "data-name": "Group 3757"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1903",
    "data-name": "Path 1903",
    d: "M403.065,231.947c0-.005-.008-.11-.013-.314,0-.22-.008-.517-.014-.9-.006-.809-.015-1.974-.027-3.485-.015-3.058-.036-7.508-.063-13.158-.029-11.307-.071-27.415-.121-46.7l.238.238-61.756.036H341.3l.275-.274c-.015,23.695-.028,45.863-.039,64.558l-.236-.235,44.721.121,12.561.061,3.324.027.858.014a2.5,2.5,0,0,1,.3.013,1.987,1.987,0,0,1-.272.013l-.834.013-3.278.028-12.508.061-44.871.12h-.235v-.237c-.011-18.695-.025-40.863-.039-64.558v-.275h.281l61.756.036h.24v.239c-.051,19.35-.093,35.51-.122,46.854-.027,5.627-.048,10.058-.063,13.1-.012,1.491-.021,2.64-.028,3.439-.005.373-.01.661-.013.875A2.077,2.077,0,0,1,403.065,231.947Z",
    fill: "#e0e0e0"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3773",
    "data-name": "Group 3773"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3772",
    "data-name": "Group 3772"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3771",
    "data-name": "Group 3771"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3770",
    "data-name": "Group 3770"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3769",
    "data-name": "Group 3769"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3768",
    "data-name": "Group 3768"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3767",
    "data-name": "Group 3767"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3766",
    "data-name": "Group 3766"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_247",
    "data-name": "Rectangle 247",
    width: 20.666,
    height: 20.666,
    transform: "translate(361.936 189.334)",
    fill: "#ebebeb"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Plant"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3933",
    "data-name": "Group 3933"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3779",
    "data-name": "Group 3779"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3776",
    "data-name": "Group 3776"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3775",
    "data-name": "Group 3775"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_248",
    "data-name": "Rectangle 248",
    width: 60.633,
    height: 8.331,
    transform: "translate(112.402 426.185)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3778",
    "data-name": "Group 3778"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3777",
    "data-name": "Group 3777"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1904",
    "data-name": "Path 1904",
    d: "M173.138,434.62H112.3v-8.539h60.84Zm-60.633-.207H172.93v-8.124H112.5Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3782",
    "data-name": "Group 3782"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3781",
    "data-name": "Group 3781"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3780",
    "data-name": "Group 3780"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1905",
    "data-name": "Path 1905",
    d: "M118.023,431.744l8.727,43.056h32.292l8.437-40.283Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3785",
    "data-name": "Group 3785"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3784",
    "data-name": "Group 3784"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3783",
    "data-name": "Group 3783"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1906",
    "data-name": "Path 1906",
    d: "M118.023,470.727l4.655,6.4h39.251l5.551-6.4Z",
    fill: "#455a64"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3789",
    "data-name": "Group 3789"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3788",
    "data-name": "Group 3788"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3787",
    "data-name": "Group 3787"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3786",
    "data-name": "Group 3786"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1907",
    "data-name": "Path 1907",
    d: "M140.441,433c-.119,0-.272-19.946-.341-44.547s-.029-44.551.09-44.552.272,19.942.342,44.551S140.56,433,140.441,433Z",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3793",
    "data-name": "Group 3793"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3792",
    "data-name": "Group 3792"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3791",
    "data-name": "Group 3791"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3790",
    "data-name": "Group 3790"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1908",
    "data-name": "Path 1908",
    d: "M153.947,383.085a2.087,2.087,0,0,1-.162.463c-.142.339-.322.766-.542,1.292q-.182.426-.395.929l-.4,1.132-.467,1.3c-.162.461-.29.963-.449,1.481a60.333,60.333,0,0,0-1.7,7.424,89.985,89.985,0,0,0-.939,9.283,125.156,125.156,0,0,0,.479,16.958c.195,2.165.391,3.914.535,5.122.063.566.113,1.028.153,1.393a2.134,2.134,0,0,1,.025.49,2.045,2.045,0,0,1-.111-.478c-.061-.362-.138-.82-.233-1.382-.2-1.2-.439-2.949-.673-5.114a111.608,111.608,0,0,1-.607-17.009,84.478,84.478,0,0,1,.978-9.329,56.222,56.222,0,0,1,1.8-7.448c.17-.518.308-1.02.481-1.48s.344-.888.5-1.295.3-.776.439-1.125.3-.643.432-.919l.617-1.261A2.074,2.074,0,0,1,153.947,383.085Z",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3797",
    "data-name": "Group 3797"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3796",
    "data-name": "Group 3796"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3795",
    "data-name": "Group 3795"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3794",
    "data-name": "Group 3794"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1909",
    "data-name": "Path 1909",
    d: "M152.4,366.952a4.082,4.082,0,0,1-.193.658l-.631,1.854q-.211.609-.464,1.337l-.487,1.611c-.355,1.154-.766,2.465-1.131,3.941q-.291,1.1-.609,2.306-.273,1.215-.568,2.522c-.424,1.736-.729,3.623-1.12,5.592-.668,3.962-1.257,8.342-1.663,12.962-.383,4.623-.55,9.04-.608,13.06-.012,4.019.039,7.64.2,10.677.053,1.519.151,2.891.229,4.1s.145,2.244.222,3.091q.093,1.225.149,1.954a4.009,4.009,0,0,1,.022.684,4.143,4.143,0,0,1-.109-.675c-.057-.485-.133-1.133-.229-1.948-.1-.845-.2-1.882-.3-3.088s-.22-2.578-.293-4.1c-.205-3.04-.287-6.668-.3-10.7.037-4.029.192-8.458.576-13.094.407-4.632,1.009-9.024,1.7-12.994.4-1.974.722-3.864,1.163-5.6l.594-2.524q.331-1.2.637-2.306c.385-1.474.818-2.784,1.2-3.934q.28-.859.523-1.6l.5-1.327q.444-1.147.708-1.83A3.95,3.95,0,0,1,152.4,366.952Z",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3801",
    "data-name": "Group 3801"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3800",
    "data-name": "Group 3800"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3799",
    "data-name": "Group 3799"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3798",
    "data-name": "Group 3798"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1910",
    "data-name": "Path 1910",
    d: "M136.606,436.53a.924.924,0,0,1-.034-.233c-.015-.179-.034-.406-.058-.687-.043-.635-.1-1.519-.178-2.641-.145-2.327-.353-5.638-.608-9.716-.526-8.2-1.287-19.534-2.668-31.995-.705-6.231-1.523-12.148-2.373-17.513-.452-2.678-.862-5.226-1.327-7.6-.426-2.377-.886-4.58-1.309-6.59-.4-2.015-.843-3.82-1.2-5.412s-.691-2.958-.975-4.071c-.268-1.092-.478-1.952-.63-2.571-.063-.275-.113-.5-.153-.671a.988.988,0,0,1-.038-.233,1,1,0,0,1,.081.221c.05.173.114.39.194.661.171.613.408,1.467.709,2.551.309,1.107.673,2.466,1.047,4.057s.845,3.39,1.264,5.4c.442,2.008.92,4.21,1.362,6.587.481,2.371.9,4.92,1.368,7.6.873,5.368,1.7,11.291,2.41,17.529,1.381,12.474,2.1,23.816,2.543,32.025.223,4.105.378,7.428.471,9.725.041,1.124.074,2.009.1,2.646.006.282.011.509.015.688A.974.974,0,0,1,136.606,436.53Z",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3804",
    "data-name": "Group 3804"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3803",
    "data-name": "Group 3803"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3802",
    "data-name": "Group 3802"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1911",
    "data-name": "Path 1911",
    d: "M139.946,353.491c-.263-2.825-3.119-4.957-5.957-4.986a9.375,9.375,0,0,0-7.219,3.918,22.6,22.6,0,0,0-3.476,7.715,52.416,52.416,0,0,0-2.138,20.53c.817,6.878,3.607,13.649,8.543,18.509.8.79,1.842,1.58,2.943,1.345a3.544,3.544,0,0,0,1.553-.959,45.942,45.942,0,0,0,14.91-34.937c-.076-2.615-.42-5.337-1.868-7.517s-4.825-4.493-7.291-3.618",
    fill: "#455a64"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3824",
    "data-name": "Group 3824"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3807",
    "data-name": "Group 3807"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3806",
    "data-name": "Group 3806"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3805",
    "data-name": "Group 3805"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1912",
    "data-name": "Path 1912",
    d: "M140.19,343.9,104.142,322.63a1.68,1.68,0,0,1-.877-.885c-.144-.533.256-1.048.641-1.445a24.846,24.846,0,0,1,19.264-7.568,22.007,22.007,0,0,1,17.416,10.832c3.479,6.216,3.594,14.437-.4,20.338",
    fill: "#455a64"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3811",
    "data-name": "Group 3811"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3810",
    "data-name": "Group 3810"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3809",
    "data-name": "Group 3809"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3808",
    "data-name": "Group 3808"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1913",
    "data-name": "Path 1913",
    d: "M109.338,315.84a2,2,0,0,1,.472-.059c.311-.015.77-.071,1.362-.065a27.148,27.148,0,0,1,5,.4,29.234,29.234,0,0,1,23.332,21.113,27.13,27.13,0,0,1,.894,4.937,10.313,10.313,0,0,1,.055,1.051,1.778,1.778,0,0,1-.278.786,6.092,6.092,0,0,0,.055-1.819,30.579,30.579,0,0,0-1.02-4.872,29.447,29.447,0,0,0-23.092-20.895,30.822,30.822,0,0,0-4.949-.53C109.994,315.858,109.339,315.879,109.338,315.84Z",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3815",
    "data-name": "Group 3815"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3814",
    "data-name": "Group 3814"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3813",
    "data-name": "Group 3813"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3812",
    "data-name": "Group 3812"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1914",
    "data-name": "Path 1914",
    d: "M135.311,329.22a8.707,8.707,0,0,1-1.822.828c-1.149.453-2.754,1.031-4.549,1.6s-3.441,1.024-4.64,1.317a8.733,8.733,0,0,1-1.966.375,9.721,9.721,0,0,1,1.884-.67l4.591-1.434,4.577-1.477A9.819,9.819,0,0,1,135.311,329.22Z",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3819",
    "data-name": "Group 3819"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3818",
    "data-name": "Group 3818"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3817",
    "data-name": "Group 3817"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3816",
    "data-name": "Group 3816"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1915",
    "data-name": "Path 1915",
    d: "M129.635,313.972a25.187,25.187,0,0,1,.2,8.059,75.6,75.6,0,0,1-.2-8.059Z",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3823",
    "data-name": "Group 3823"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3822",
    "data-name": "Group 3822"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3821",
    "data-name": "Group 3821"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3820",
    "data-name": "Group 3820"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1916",
    "data-name": "Path 1916",
    d: "M103.827,322.227a16.19,16.19,0,0,1,2.619-.921c1.638-.505,3.919-1.145,6.461-1.758s4.866-1.082,6.553-1.378a16.074,16.074,0,0,1,2.751-.372,19.333,19.333,0,0,1-2.691.672c-1.669.372-3.975.888-6.512,1.5s-4.823,1.2-6.479,1.631A19.345,19.345,0,0,1,103.827,322.227Z",
    fill: "#263238"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3848",
    "data-name": "Group 3848"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3827",
    "data-name": "Group 3827"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3826",
    "data-name": "Group 3826"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3825",
    "data-name": "Group 3825"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1917",
    "data-name": "Path 1917",
    d: "M124.985,347.36c-3.1-2.351-6.379-2.814-10.267-2.66a31.389,31.389,0,0,0-11.236,2.9c-6.079,2.663-11.792,6.587-15.424,12.14s-4.9,12.907-2.177,18.96a2.7,2.7,0,0,0,1.231,1.494,2.942,2.942,0,0,0,2.035-.156c6.913-2.255,13.876-4.532,20.232-8.063s12.143-8.442,15.554-14.864a12.768,12.768,0,0,0,1.638-4.933,6.134,6.134,0,0,0-1.586-4.817",
    fill: "#455a64"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3831",
    "data-name": "Group 3831"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3830",
    "data-name": "Group 3830"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3829",
    "data-name": "Group 3829"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3828",
    "data-name": "Group 3828"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1918",
    "data-name": "Path 1918",
    d: "M125.046,346.631a2.574,2.574,0,0,1-.5.2l-1.448.5-1.049.35c-.38.136-.786.307-1.226.477-.874.354-1.89.707-2.959,1.226l-1.695.772c-.588.272-1.175.606-1.8.922-1.254.616-2.521,1.4-3.871,2.2A61.188,61.188,0,0,0,95.252,366.7c-.963,1.238-1.9,2.4-2.674,3.56-.394.576-.8,1.116-1.143,1.664l-.982,1.583c-.651.995-1.131,1.957-1.593,2.779-.225.415-.446.795-.63,1.155s-.334.692-.48,1c-.279.563-.5,1.018-.679,1.373a2.535,2.535,0,0,1-.264.468,2.535,2.535,0,0,1,.184-.5l.607-1.41.448-1.015c.173-.367.384-.754.6-1.176.444-.836.907-1.814,1.545-2.823l.963-1.607c.339-.556.74-1.1,1.129-1.688.763-1.18,1.7-2.353,2.66-3.606a59.209,59.209,0,0,1,15.352-13.506c1.365-.794,2.647-1.573,3.915-2.179.629-.312,1.223-.64,1.818-.9l1.716-.751c1.083-.5,2.111-.839,3-1.173.446-.16.857-.319,1.243-.445l1.064-.315,1.476-.422A2.371,2.371,0,0,1,125.046,346.631Z",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3835",
    "data-name": "Group 3835"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3834",
    "data-name": "Group 3834"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3833",
    "data-name": "Group 3833"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3832",
    "data-name": "Group 3832"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1919",
    "data-name": "Path 1919",
    d: "M100.825,359.745a72.631,72.631,0,0,1-7.542,2.43,72.981,72.981,0,0,1-7.663,2.016,72.428,72.428,0,0,1,7.542-2.43A72.843,72.843,0,0,1,100.825,359.745Z",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3839",
    "data-name": "Group 3839"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3838",
    "data-name": "Group 3838"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3837",
    "data-name": "Group 3837"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3836",
    "data-name": "Group 3836"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1920",
    "data-name": "Path 1920",
    d: "M100.514,376.388a12.09,12.09,0,0,1-.165-2.35c-.04-1.453-.046-3.461.015-5.677s.181-4.223.3-5.671a12,12,0,0,1,.3-2.337,13.387,13.387,0,0,1,.008,2.354c-.049,1.592-.109,3.526-.175,5.665s-.1,4.074-.142,5.666A13.36,13.36,0,0,1,100.514,376.388Z",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3843",
    "data-name": "Group 3843"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3842",
    "data-name": "Group 3842"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3841",
    "data-name": "Group 3841"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3840",
    "data-name": "Group 3840"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1921",
    "data-name": "Path 1921",
    d: "M114.771,369.125c-.119.008-.5-4.073-.847-9.113s-.535-9.136-.416-9.144.5,4.071.847,9.114S114.89,369.117,114.771,369.125Z",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3847",
    "data-name": "Group 3847"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3846",
    "data-name": "Group 3846"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3845",
    "data-name": "Group 3845"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3844",
    "data-name": "Group 3844"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1922",
    "data-name": "Path 1922",
    d: "M97.025,350.472a13.409,13.409,0,0,1,2.417-.073c1.491.01,3.549.054,5.82.129s4.328.167,5.816.255a13.438,13.438,0,0,1,2.407.233,13.332,13.332,0,0,1-2.414.073c-1.49-.01-3.549-.054-5.823-.129s-4.331-.168-5.819-.256A13.525,13.525,0,0,1,97.025,350.472Z",
    fill: "#263238"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3852",
    "data-name": "Group 3852"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3851",
    "data-name": "Group 3851"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3850",
    "data-name": "Group 3850"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3849",
    "data-name": "Group 3849"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1923",
    "data-name": "Path 1923",
    d: "M131.245,400.125a2.075,2.075,0,0,1-.052-.482c-.016-.363-.037-.822-.063-1.387-.054-1.2-.067-2.95-.02-5.105s.185-4.721.444-7.562c.281-2.838.687-5.95,1.269-9.192.6-3.241,1.314-6.3,2.052-9.059.758-2.753,1.526-5.21,2.249-7.247s1.344-3.672,1.82-4.784c.223-.521.4-.944.548-1.279a2.082,2.082,0,0,1,.219-.436,2.048,2.048,0,0,1-.138.467c-.124.342-.28.775-.472,1.307-.427,1.128-1.009,2.774-1.687,4.819s-1.419,4.5-2.154,7.252c-.714,2.755-1.416,5.8-2.011,9.034-.58,3.23-1,6.329-1.3,9.156-.281,2.829-.458,5.384-.536,7.533s-.12,3.891-.117,5.094c-.007.564-.013,1.024-.018,1.386A2.026,2.026,0,0,1,131.245,400.125Z",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3856",
    "data-name": "Group 3856"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3855",
    "data-name": "Group 3855"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3854",
    "data-name": "Group 3854"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3853",
    "data-name": "Group 3853"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1924",
    "data-name": "Path 1924",
    d: "M133.146,376.523a9.877,9.877,0,0,1-1.437,1.578c-.933.93-2.257,2.179-3.768,3.5s-2.923,2.474-3.967,3.277a9.951,9.951,0,0,1-1.753,1.219,11.089,11.089,0,0,1,1.559-1.456l3.876-3.365,3.844-3.4A11.2,11.2,0,0,1,133.146,376.523Z",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3860",
    "data-name": "Group 3860"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3859",
    "data-name": "Group 3859"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3858",
    "data-name": "Group 3858"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3857",
    "data-name": "Group 3857"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1925",
    "data-name": "Path 1925",
    d: "M144.557,385.714a16.892,16.892,0,0,1-1.532-2.121l-3.562-5.2-3.637-5.147a16.83,16.83,0,0,1-1.456-2.174,14.568,14.568,0,0,1,1.7,1.991c1,1.27,2.337,3.059,3.747,5.084s2.62,3.9,3.464,5.279A14.745,14.745,0,0,1,144.557,385.714Z",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3864",
    "data-name": "Group 3864"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3863",
    "data-name": "Group 3863"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3862",
    "data-name": "Group 3862"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3861",
    "data-name": "Group 3861"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1926",
    "data-name": "Path 1926",
    d: "M138.58,356.808c.064.1-3.726,2.652-8.465,5.7s-8.635,5.436-8.7,5.336,3.725-2.652,8.465-5.7S138.515,356.708,138.58,356.808Z",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3868",
    "data-name": "Group 3868"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3867",
    "data-name": "Group 3867"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3866",
    "data-name": "Group 3866"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3865",
    "data-name": "Group 3865"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1927",
    "data-name": "Path 1927",
    d: "M149.267,368.343a70.548,70.548,0,0,1-5.733-5.3,70.469,70.469,0,0,1-5.431-5.607,70.882,70.882,0,0,1,5.733,5.3A71.016,71.016,0,0,1,149.267,368.343Z",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3892",
    "data-name": "Group 3892"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3871",
    "data-name": "Group 3871"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3870",
    "data-name": "Group 3870"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3869",
    "data-name": "Group 3869"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1928",
    "data-name": "Path 1928",
    d: "M151.955,368.112l3.253-.269a16.111,16.111,0,0,0,6.571-2.012,26.154,26.154,0,0,1,3.062-1.538c4.023-1.615,8.512-1.326,12.841-1.543a53.187,53.187,0,0,0,20.426-5.223,1.982,1.982,0,0,0,.89-.808c.669-1.217-.573-2.3-1.641-2.96-5.482-3.378-11.062-6.8-17.278-8.475s-13.273-1.393-18.577,2.257c-6.227,4.285-8.495,13.086-9.547,20.571",
    fill: "#455a64"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3875",
    "data-name": "Group 3875"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3874",
    "data-name": "Group 3874"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3873",
    "data-name": "Group 3873"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3872",
    "data-name": "Group 3872"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1929",
    "data-name": "Path 1929",
    d: "M199.072,356.319a3.207,3.207,0,0,1-.552-.257l-1.542-.807c-1.338-.7-3.264-1.742-5.7-2.909a53.243,53.243,0,0,0-8.818-3.4,29.105,29.105,0,0,0-11.428-.926,19.544,19.544,0,0,0-10.418,4.474,23.173,23.173,0,0,0-5.424,7.619,63.777,63.777,0,0,0-2.361,5.933c-.24.681-.432,1.226-.579,1.641a3.164,3.164,0,0,1-.227.564,3.177,3.177,0,0,1,.144-.591q.19-.631.5-1.667a54.171,54.171,0,0,1,2.242-6.008,23.053,23.053,0,0,1,5.439-7.789,19.75,19.75,0,0,1,10.625-4.6,29.089,29.089,0,0,1,11.591.971,51.153,51.153,0,0,1,8.844,3.507c2.425,1.206,4.33,2.286,5.644,3.035l1.5.879A3.293,3.293,0,0,1,199.072,356.319Z",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3879",
    "data-name": "Group 3879"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3878",
    "data-name": "Group 3878"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3877",
    "data-name": "Group 3877"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3876",
    "data-name": "Group 3876"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1930",
    "data-name": "Path 1930",
    d: "M191.258,360.517c-.067.1-4.323-2.654-9.5-6.148s-9.33-6.407-9.264-6.506,4.322,2.653,9.5,6.148S191.324,360.418,191.258,360.517Z",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3883",
    "data-name": "Group 3883"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3882",
    "data-name": "Group 3882"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3881",
    "data-name": "Group 3881"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3880",
    "data-name": "Group 3880"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1931",
    "data-name": "Path 1931",
    d: "M186.719,347.639a10.4,10.4,0,0,1-3.1.557,10.535,10.535,0,0,1-3.159-.041,20.433,20.433,0,0,1,3.122-.319A20.494,20.494,0,0,1,186.719,347.639Z",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3887",
    "data-name": "Group 3887"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3886",
    "data-name": "Group 3886"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3885",
    "data-name": "Group 3885"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3884",
    "data-name": "Group 3884"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1932",
    "data-name": "Path 1932",
    d: "M168.09,345.211a8.266,8.266,0,0,1-1.4,2.181,9.347,9.347,0,0,1-1.768,2.009,8.251,8.251,0,0,1,1.4-2.181A9.347,9.347,0,0,1,168.09,345.211Z",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3891",
    "data-name": "Group 3891"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3890",
    "data-name": "Group 3890"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3889",
    "data-name": "Group 3889"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3888",
    "data-name": "Group 3888"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1933",
    "data-name": "Path 1933",
    d: "M171.9,363.024a11.192,11.192,0,0,1-2.048-1.11c-1.23-.746-2.891-1.84-4.666-3.128s-3.34-2.508-4.465-3.4a12.632,12.632,0,0,1-1.767-1.515,12.348,12.348,0,0,1,1.951,1.271l4.535,3.3c1.769,1.284,3.394,2.412,4.577,3.221A13.9,13.9,0,0,1,171.9,363.024Z",
    fill: "#263238"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3916",
    "data-name": "Group 3916"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3895",
    "data-name": "Group 3895"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3894",
    "data-name": "Group 3894"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3893",
    "data-name": "Group 3893"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1934",
    "data-name": "Path 1934",
    d: "M156.745,381.936c-3.1-.82-6.8,2.2-7.442,5.344s.54,6.363,1.921,9.26a47.232,47.232,0,0,0,12.834,16.792,31.725,31.725,0,0,0,19.623,7.224c-1.312-6.094.348-12.46-.384-18.651a24.26,24.26,0,0,0-21.488-21.274c-1.981-.214-4.273-.525-5.064,1.3",
    fill: "#455a64"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3899",
    "data-name": "Group 3899"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3898",
    "data-name": "Group 3898"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3897",
    "data-name": "Group 3897"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3896",
    "data-name": "Group 3896"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1935",
    "data-name": "Path 1935",
    d: "M183.681,420.556a2.044,2.044,0,0,1-.442-.2,8.038,8.038,0,0,1-1.16-.779,12.109,12.109,0,0,1-3.065-4.1c-.5-.96-1.047-2-1.588-3.159l-1.67-3.691a35.864,35.864,0,0,0-2.051-3.944,30.992,30.992,0,0,0-2.824-3.841c-2.125-2.5-4.4-4.654-6.381-6.717a43.913,43.913,0,0,1-4.865-5.837,21.448,21.448,0,0,1-2.377-4.541,13.921,13.921,0,0,1-.415-1.331,2.112,2.112,0,0,1-.1-.476c.041-.012.216.633.67,1.746a23.4,23.4,0,0,0,2.472,4.429,46.274,46.274,0,0,0,4.9,5.733c1.985,2.04,4.277,4.194,6.425,6.715a30.587,30.587,0,0,1,2.855,3.9,35.083,35.083,0,0,1,2.053,4c.574,1.3,1.12,2.542,1.632,3.7s1.059,2.2,1.535,3.169a12.542,12.542,0,0,0,2.9,4.11C183.093,420.225,183.707,420.515,183.681,420.556Z",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3903",
    "data-name": "Group 3903"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3902",
    "data-name": "Group 3902"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3901",
    "data-name": "Group 3901"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3900",
    "data-name": "Group 3900"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1936",
    "data-name": "Path 1936",
    d: "M167.633,415.492a9.226,9.226,0,0,1,.285-2.089c.243-1.278.641-3.032,1.179-4.944s1.115-3.617,1.575-4.833a9.267,9.267,0,0,1,.847-1.931,11.3,11.3,0,0,1-.558,2.03c-.385,1.238-.912,2.948-1.448,4.851s-.979,3.636-1.3,4.893A11.39,11.39,0,0,1,167.633,415.492Z",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3907",
    "data-name": "Group 3907"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3906",
    "data-name": "Group 3906"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3905",
    "data-name": "Group 3905"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3904",
    "data-name": "Group 3904"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1937",
    "data-name": "Path 1937",
    d: "M183.093,400.533a12.663,12.663,0,0,1-2.186-.5c-1.338-.35-3.184-.827-5.238-1.291s-3.929-.822-5.287-1.079a12.854,12.854,0,0,1-2.19-.483,10.538,10.538,0,0,1,2.239.181c1.374.181,3.266.495,5.332.96s3.91.993,5.229,1.419A10.609,10.609,0,0,1,183.093,400.533Z",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3911",
    "data-name": "Group 3911"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3910",
    "data-name": "Group 3910"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3909",
    "data-name": "Group 3909"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3908",
    "data-name": "Group 3908"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1938",
    "data-name": "Path 1938",
    d: "M156.116,404.88a12.7,12.7,0,0,1,.336-2.418c.273-1.481.707-3.518,1.287-5.743s1.2-4.216,1.685-5.641a12.687,12.687,0,0,1,.888-2.273,14.716,14.716,0,0,1-.6,2.363c-.41,1.446-.978,3.442-1.558,5.66s-1.058,4.235-1.406,5.7A14.815,14.815,0,0,1,156.116,404.88Z",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3915",
    "data-name": "Group 3915"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3914",
    "data-name": "Group 3914"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3913",
    "data-name": "Group 3913"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3912",
    "data-name": "Group 3912"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1939",
    "data-name": "Path 1939",
    d: "M175.973,387.5c-.013.118-3.887-.195-8.652-.7s-8.621-1.012-8.608-1.13,3.886.2,8.653.7S175.986,387.379,175.973,387.5Z",
    fill: "#263238"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3920",
    "data-name": "Group 3920"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3919",
    "data-name": "Group 3919"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3918",
    "data-name": "Group 3918"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3917",
    "data-name": "Group 3917"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1940",
    "data-name": "Path 1940",
    d: "M173.135,434.481c0,.12-13.619.216-30.416.216s-30.418-.1-30.418-.216,13.616-.216,30.418-.216S173.135,434.362,173.135,434.481Z",
    fill: "#455a64"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3924",
    "data-name": "Group 3924"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3923",
    "data-name": "Group 3923"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3922",
    "data-name": "Group 3922"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3921",
    "data-name": "Group 3921"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1941",
    "data-name": "Path 1941",
    d: "M163.659,452.007c0,.12-9.176.217-20.493.217s-20.494-.1-20.494-.217,9.174-.215,20.494-.215S163.659,451.888,163.659,452.007Z",
    fill: "#455a64"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3928",
    "data-name": "Group 3928"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3927",
    "data-name": "Group 3927"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3926",
    "data-name": "Group 3926"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3925",
    "data-name": "Group 3925"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1942",
    "data-name": "Path 1942",
    d: "M163.3,454.513c0,.12-9.016.216-20.136.216s-20.138-.1-20.138-.216,9.015-.216,20.138-.216S163.3,454.394,163.3,454.513Z",
    fill: "#455a64"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3932",
    "data-name": "Group 3932"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3931",
    "data-name": "Group 3931"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3930",
    "data-name": "Group 3930"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3929",
    "data-name": "Group 3929"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1943",
    "data-name": "Path 1943",
    d: "M164.017,449.942c0,.119-9.491.216-21.2.216s-21.2-.1-21.2-.216,9.489-.216,21.2-.216S164.017,449.823,164.017,449.942Z",
    fill: "#455a64"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Speech_Bubble",
    "data-name": "Speech Bubble"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3953",
    "data-name": "Group 3953"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3943",
    "data-name": "Group 3943"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3942",
    "data-name": "Group 3942"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3941",
    "data-name": "Group 3941"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3940",
    "data-name": "Group 3940"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3939",
    "data-name": "Group 3939"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3935",
    "data-name": "Group 3935"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3934",
    "data-name": "Group 3934"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1944",
    "data-name": "Path 1944",
    d: "M316.333,106.884l7.549-13.3a35.648,35.648,0,1,1,8.538,9.5l.012.016Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3938",
    "data-name": "Group 3938"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3937",
    "data-name": "Group 3937"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3936",
    "data-name": "Group 3936"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1945",
    "data-name": "Path 1945",
    d: "M316.333,106.884l16.072-3.905-.067.185-.012-.015a.119.119,0,0,1,.022-.165.117.117,0,0,1,.143,0,36.47,36.47,0,0,0,7.294,4.34,35.53,35.53,0,0,0,9.691,2.722,31.751,31.751,0,0,0,5.585.262c.96-.058,1.938-.084,2.923-.169l2.977-.459a35.6,35.6,0,0,0,21.973-14.172,35.109,35.109,0,0,0,5.926-13.594,35.9,35.9,0,0,0-.427-15.639A34.708,34.708,0,0,0,380.9,51.823l-1.435-1.579c-.472-.531-1.035-.969-1.546-1.456-.535-.461-1.017-.984-1.593-1.39l-1.687-1.262a14.658,14.658,0,0,0-1.746-1.156L371.107,43.9l-1.867-.907a16.213,16.213,0,0,0-1.884-.839A35.915,35.915,0,0,0,351.6,39.718a34.732,34.732,0,0,0-14.476,4.257,35.789,35.789,0,0,0-16.758,20.531,38.273,38.273,0,0,0-1.572,11.465,35.384,35.384,0,0,0,5.185,17.55.115.115,0,0,1,0,.115c-4.874,8.445-7.246,12.554-7.647,13.248l7.451-13.359,0,.114a35.439,35.439,0,0,1-5.318-17.659A38.437,38.437,0,0,1,320.014,64.4a36.13,36.13,0,0,1,16.9-20.8,35.133,35.133,0,0,1,14.651-4.331,36.336,36.336,0,0,1,15.964,2.452,16.816,16.816,0,0,1,1.909.849l1.892.919,1.807,1.1a15.121,15.121,0,0,1,1.769,1.17l1.71,1.278c.582.413,1.072.941,1.614,1.408.518.494,1.088.938,1.566,1.476l1.455,1.6a35.127,35.127,0,0,1,7.633,14.647A36.313,36.313,0,0,1,389.3,82a35.5,35.5,0,0,1-6.019,13.757,35.925,35.925,0,0,1-22.255,14.284l-3.008.455c-1,.083-1.984.106-2.953.161a32.021,32.021,0,0,1-5.638-.286,35.7,35.7,0,0,1-9.763-2.789,36.423,36.423,0,0,1-7.321-4.416l.165-.164.012.016a.117.117,0,0,1-.021.164.113.113,0,0,1-.046.021Z",
    fill: "#263238"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3952",
    "data-name": "Group 3952"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3951",
    "data-name": "Group 3951"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3950",
    "data-name": "Group 3950"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3946",
    "data-name": "Group 3946"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3945",
    "data-name": "Group 3945"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3944",
    "data-name": "Group 3944"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1946",
    "data-name": "Path 1946",
    d: "M348.1,70.605h2.317l5.056-7.046V58.935s3.58-.22,3.159,5.835.034,4.514.034,4.514,7.6.029,8.236.689c.459.48.667,8.033.746,12.129a4.433,4.433,0,0,1-3.142,4.467,3.3,3.3,0,0,1-.818.11c-1.9,0-11.586-1.542-11.586-1.542h-4Z",
    fill: "#ff725e"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3949",
    "data-name": "Group 3949"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3948",
    "data-name": "Group 3948"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3947",
    "data-name": "Group 3947"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1947",
    "data-name": "Path 1947",
    d: "M341.471,69.336,342.9,85.181h3.967V69.655Z",
    fill: "#ff725e"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Character"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4181",
    "data-name": "Group 4181"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1948",
    "data-name": "Path 1948",
    d: "M230.888,103.361a34.091,34.091,0,0,1-18.674,5.33c-2.1-.027-4.193-.247-6.28-.069a9.537,9.537,0,0,0-5.749,2.231,5.237,5.237,0,0,0-1.473,5.705c1.18,2.7,5,3.775,5.579,6.665.416,2.08-1.134,4.061-2.877,5.269s-3.795,2.01-5.265,3.538a7.234,7.234,0,0,0,3.587,12.064c1.493.344,3.325.353,4.135,1.654a4.725,4.725,0,0,1,.217,3.129,11.169,11.169,0,0,0,.855,6.586,6.116,6.116,0,0,0,5.368,3.469c.878-.031,1.739-.3,2.617-.283a2.173,2.173,0,0,1,2.113,1.27,4.49,4.49,0,0,1-.085,1.8c-.318,2.952,2.624,5.252,5.469,6.1,5.69,1.7,12.045.059,16.84-3.442s8.159-8.681,10.4-14.177,3.458-11.349,4.659-17.164",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4063",
    "data-name": "Group 4063"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1949",
    "data-name": "Path 1949",
    d: "M294.451,250.446a12.41,12.41,0,0,0-2.813-4.19c-7.529-8.013-18.934-11.841-29.912-11.218s-21.474,5.4-30.025,12.317c-4.555,3.682-10.686,10.8-12.288,16.432,6.679,1.611,16.662-.631,22.96-3.377s12.533-6.074,19.368-6.769c7.922-.807,15.7,2.006,23.5,3.586a14.737,14.737,0,0,0,4.763.383,5.687,5.687,0,0,0,4.059-2.277A5.565,5.565,0,0,0,294.451,250.446Z",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3954",
    "data-name": "Group 3954",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1950",
    "data-name": "Path 1950",
    d: "M294.451,250.446a12.41,12.41,0,0,0-2.813-4.19c-7.529-8.013-18.934-11.841-29.912-11.218s-21.474,5.4-30.025,12.317c-4.555,3.682-10.686,10.8-12.288,16.432,6.679,1.611,16.662-.631,22.96-3.377s12.533-6.074,19.368-6.769c7.922-.807,15.7,2.006,23.5,3.586a14.737,14.737,0,0,0,4.763.383,5.687,5.687,0,0,0,4.059-2.277A5.565,5.565,0,0,0,294.451,250.446Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4038",
    "data-name": "Group 4038"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4037",
    "data-name": "Group 4037"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3965",
    "data-name": "Group 3965"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3964",
    "data-name": "Group 3964"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3963",
    "data-name": "Group 3963"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3962",
    "data-name": "Group 3962"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3961",
    "data-name": "Group 3961"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3960",
    "data-name": "Group 3960"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3959",
    "data-name": "Group 3959"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3958",
    "data-name": "Group 3958"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3957",
    "data-name": "Group 3957"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3956",
    "data-name": "Group 3956"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3955",
    "data-name": "Group 3955"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1951",
    "data-name": "Path 1951",
    d: "M288.987,345.853,308.058,333.5s18.965,15.234,22.711,13.294l-22.63-37.838-30.505,18.034Z",
    fill: "#ff725e"
  })))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3977",
    "data-name": "Group 3977"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3976",
    "data-name": "Group 3976"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3975",
    "data-name": "Group 3975"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3974",
    "data-name": "Group 3974"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3973",
    "data-name": "Group 3973"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3972",
    "data-name": "Group 3972"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3971",
    "data-name": "Group 3971"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3970",
    "data-name": "Group 3970"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3969",
    "data-name": "Group 3969"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3968",
    "data-name": "Group 3968"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3967",
    "data-name": "Group 3967"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3966",
    "data-name": "Group 3966"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1952",
    "data-name": "Path 1952",
    d: "M299.42,322.776a1.8,1.8,0,0,1,1.125-2.123,1.731,1.731,0,0,1,2.114,1.1,1.9,1.9,0,0,1-1.2,2.242,1.8,1.8,0,0,1-2.073-1.383",
    fill: "#e0e0e0"
  }))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3988",
    "data-name": "Group 3988",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3987",
    "data-name": "Group 3987"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3986",
    "data-name": "Group 3986"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3985",
    "data-name": "Group 3985"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3984",
    "data-name": "Group 3984"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3983",
    "data-name": "Group 3983"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3982",
    "data-name": "Group 3982"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3981",
    "data-name": "Group 3981"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3980",
    "data-name": "Group 3980"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3979",
    "data-name": "Group 3979"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3978",
    "data-name": "Group 3978"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1953",
    "data-name": "Path 1953",
    d: "M308.139,308.952l-3,1.938,22.821,35.554s1.741,1.246,2.813.346Z",
    fill: "#fff"
  })))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4000",
    "data-name": "Group 4000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3999",
    "data-name": "Group 3999"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3998",
    "data-name": "Group 3998"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3997",
    "data-name": "Group 3997"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3996",
    "data-name": "Group 3996"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3995",
    "data-name": "Group 3995"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3994",
    "data-name": "Group 3994"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3993",
    "data-name": "Group 3993"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3992",
    "data-name": "Group 3992"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3991",
    "data-name": "Group 3991"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3990",
    "data-name": "Group 3990"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3989",
    "data-name": "Group 3989"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1954",
    "data-name": "Path 1954",
    d: "M308.232,334.224c.181-.116-.288-1.09-.237-2.355.017-1.265.537-2.213.362-2.339-.138-.149-1.077.787-1.111,2.319S308.087,334.366,308.232,334.224Z",
    fill: "#263238"
  }))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4012",
    "data-name": "Group 4012"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4011",
    "data-name": "Group 4011"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4010",
    "data-name": "Group 4010"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4009",
    "data-name": "Group 4009"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4008",
    "data-name": "Group 4008"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4007",
    "data-name": "Group 4007"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4006",
    "data-name": "Group 4006"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4005",
    "data-name": "Group 4005"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4004",
    "data-name": "Group 4004"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4003",
    "data-name": "Group 4003"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4002",
    "data-name": "Group 4002"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4001",
    "data-name": "Group 4001"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1955",
    "data-name": "Path 1955",
    d: "M312.247,337.211c.2-.064.04-1.053.446-2.148.374-1.106,1.124-1.77,1.006-1.949-.074-.191-1.233.328-1.712,1.7S312.069,337.313,312.247,337.211Z",
    fill: "#263238"
  }))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4024",
    "data-name": "Group 4024"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4023",
    "data-name": "Group 4023"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4022",
    "data-name": "Group 4022"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4021",
    "data-name": "Group 4021"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4020",
    "data-name": "Group 4020"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4019",
    "data-name": "Group 4019"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4018",
    "data-name": "Group 4018"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4017",
    "data-name": "Group 4017"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4016",
    "data-name": "Group 4016"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4015",
    "data-name": "Group 4015"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4014",
    "data-name": "Group 4014"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4013",
    "data-name": "Group 4013"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1956",
    "data-name": "Path 1956",
    d: "M318.345,336.624c-.061-.191-1.138.1-1.866,1.184s-.614,2.184-.413,2.17c.214.014.422-.872,1.033-1.749C317.689,337.338,318.437,336.819,318.345,336.624Z",
    fill: "#263238"
  }))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4036",
    "data-name": "Group 4036"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4035",
    "data-name": "Group 4035"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4034",
    "data-name": "Group 4034"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4033",
    "data-name": "Group 4033"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4032",
    "data-name": "Group 4032"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4031",
    "data-name": "Group 4031"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4030",
    "data-name": "Group 4030"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4029",
    "data-name": "Group 4029"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4028",
    "data-name": "Group 4028"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4027",
    "data-name": "Group 4027"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4026",
    "data-name": "Group 4026"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4025",
    "data-name": "Group 4025"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1957",
    "data-name": "Path 1957",
    d: "M303.573,336.558c.123-.178-.639-.873-1.193-1.96-.576-1.075-.711-2.1-.927-2.1-.2-.027-.407,1.175.263,2.446S303.482,336.736,303.573,336.558Z",
    fill: "#263238"
  })))))))))))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1958",
    "data-name": "Path 1958",
    d: "M292.007,318.489l8.677,19.785-2.909,2.055-10.006-19.286Z",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4062",
    "data-name": "Group 4062"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1959",
    "data-name": "Path 1959",
    d: "M280.651,240.876c-.784,0-26.434-.562-40.282,8.583l-10.963,6.181.3,11.1s-2.352,3.919-1.829,6.271-.076,12.28-.076,12.28-4.1.261-4.627,7.315c0,0-5.7,2.352-8.2,6.532s-28.113,51.21-29.681,58.787-2.612,20.9,3.136,25.343,18.55,2.874,18.55,2.874,1.829,5.487,13.064,5.748,28.479-12.8,28.479-12.8l51.732-35.272L288.01,317.606l-18.071,11.058L289.273,306.2s8.884-15.154,6.271-31.092C293.6,263.271,280.651,240.876,280.651,240.876Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4039",
    "data-name": "Group 4039"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1960",
    "data-name": "Path 1960",
    d: "M285.076,249.016a2.729,2.729,0,0,1-.609.032l-1.741-.007c-1.512-.013-3.7-.049-6.4-.016s-5.914.129-9.458.507a51.915,51.915,0,0,0-11.3,2.362c-7.8,2.633-14.087,6.824-18.557,9.812l-5.259,3.644-1.435.987a2.712,2.712,0,0,1-.521.316,2.742,2.742,0,0,1,.459-.4l1.378-1.067c1.205-.913,2.957-2.224,5.169-3.784,4.425-3.069,10.709-7.337,18.6-10a50.844,50.844,0,0,1,11.419-2.346,92.279,92.279,0,0,1,9.506-.4c2.707.014,4.894.106,6.4.181l1.739.1A2.66,2.66,0,0,1,285.076,249.016Z",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4040",
    "data-name": "Group 4040"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1961",
    "data-name": "Path 1961",
    d: "M232.295,257.155a2.962,2.962,0,0,0-.819,1.5,1.8,1.8,0,0,0,.547,1.615,1.851,1.851,0,0,0,3.162-1.263,1.8,1.8,0,0,0-.717-1.547,2.962,2.962,0,0,0-1.629-.526c-.008-.028.155-.123.49-.152a2.17,2.17,0,0,1,1.356.38,2.144,2.144,0,0,1,.979,1.867,2.3,2.3,0,0,1-3.973,1.587,2.143,2.143,0,0,1-.577-2.028,2.173,2.173,0,0,1,.721-1.21C232.1,257.173,232.282,257.129,232.295,257.155Z",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4041",
    "data-name": "Group 4041"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1962",
    "data-name": "Path 1962",
    d: "M241.5,258.512c-.048.045-.412-.221-.921-.744a4.716,4.716,0,0,1-1.243-5.362c.227-.693.436-1.092.5-1.073s-.012.464-.143,1.163a5.166,5.166,0,0,0,1.167,5.034C241.283,258.1,241.553,258.459,241.5,258.512Z",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4042",
    "data-name": "Group 4042"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1963",
    "data-name": "Path 1963",
    d: "M243.669,257.185c-.044.047-.4-.175-.867-.669a5.9,5.9,0,0,1-1.308-2.3,6.052,6.052,0,0,1-.055-3.689c.182,0,.026,1.667.553,3.539A15.422,15.422,0,0,0,243.669,257.185Z",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4043",
    "data-name": "Group 4043"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1964",
    "data-name": "Path 1964",
    d: "M271.359,249.016c-.081,0-.106-.468-.181-1.2a9.649,9.649,0,0,0-.625-2.753,7.971,7.971,0,0,0-1.56-2.334c-.5-.542-.827-.872-.778-.932s.453.176,1.034.668a6.386,6.386,0,0,1,1.785,2.4,7.268,7.268,0,0,1,.512,2.939A2.538,2.538,0,0,1,271.359,249.016Z",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4044",
    "data-name": "Group 4044"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1965",
    "data-name": "Path 1965",
    d: "M274.718,248.947c-.074-.007-.087-.466-.081-1.2a9.533,9.533,0,0,0-.226-2.756,11.994,11.994,0,0,0-1.3-2.459c-.385-.624-.6-1.029-.542-1.072s.378.286.843.859a8.232,8.232,0,0,1,1.5,2.519,7.112,7.112,0,0,1,.1,2.936C274.9,248.509,274.787,248.953,274.718,248.947Z",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4045",
    "data-name": "Group 4045"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1966",
    "data-name": "Path 1966",
    d: "M230.492,362.576a4.821,4.821,0,0,1,.467-1.168c.349-.747.89-1.835,1.6-3.23,1.418-2.788,3.517-6.8,6.136-11.74,5.238-9.882,12.561-23.487,20.7-38.483,2.04-3.748,4.032-7.407,5.955-10.942A48.457,48.457,0,0,0,270.6,266.9a49.425,49.425,0,0,0-3.688-12.638c-.637-1.424-1.186-2.506-1.566-3.235l-.436-.828a1.521,1.521,0,0,1-.134-.292,1.482,1.482,0,0,1,.18.265l.482.8c.411.714.99,1.784,1.658,3.2a47.953,47.953,0,0,1,2.929,32.235,48.366,48.366,0,0,1-4.227,10.839L259.855,308.2c-8.13,14.985-15.49,28.552-20.838,38.408-2.639,4.9-4.78,8.876-6.28,11.66l-1.684,3.182c-.176.346-.317.62-.426.833A1.845,1.845,0,0,1,230.492,362.576Z",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4046",
    "data-name": "Group 4046"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1967",
    "data-name": "Path 1967",
    d: "M288.2,328.743a3.275,3.275,0,0,1-.56.394l-1.657,1.044-6.127,3.781c-5.173,3.193-12.293,7.644-20.077,12.686s-14.769,9.711-19.824,13.088l-5.994,3.99-1.642,1.066a3.4,3.4,0,0,1-.593.343,3.385,3.385,0,0,1,.534-.429c.4-.294.932-.674,1.586-1.147l5.9-4.128c5-3.455,11.958-8.171,19.748-13.22s14.945-9.45,20.169-12.564c2.612-1.557,4.736-2.8,6.214-3.641l1.708-.959A3.448,3.448,0,0,1,288.2,328.743Z",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4047",
    "data-name": "Group 4047"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1968",
    "data-name": "Path 1968",
    d: "M296.29,346.5a4.806,4.806,0,0,1-.479-1.039q-.51-1.158-1.252-2.839c-1.079-2.389-2.62-5.669-4.344-9.282-1.7-3.56-3.234-6.778-4.416-9.257l-1.308-2.82a4.888,4.888,0,0,1-.419-1.065,4.781,4.781,0,0,1,.6.974c.356.643.855,1.582,1.457,2.748,1.205,2.334,2.829,5.578,4.556,9.2s3.216,6.926,4.212,9.361c.5,1.215.869,2.216,1.1,2.913A4.84,4.84,0,0,1,296.29,346.5Z",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4048",
    "data-name": "Group 4048"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1969",
    "data-name": "Path 1969",
    d: "M230.491,362.577c-.094-.109,8.753-7.93,19.759-17.467s20.007-17.183,20.1-17.075-8.751,7.928-19.76,17.469S230.585,362.685,230.491,362.577Z",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4049",
    "data-name": "Group 4049"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1970",
    "data-name": "Path 1970",
    d: "M219.533,380.907a12.121,12.121,0,0,0,2.126-2.369c1.068-1.656,2.385-4.1,3.86-6.752,1.46-2.67,2.731-5.115,3.651-6.886a22.508,22.508,0,0,1,1.56-2.835,17.939,17.939,0,0,1-1.229,3c-.837,1.816-2.06,4.295-3.525,6.973a77.849,77.849,0,0,1-4.016,6.715,8.151,8.151,0,0,1-1.659,1.728A2.023,2.023,0,0,1,219.533,380.907Z",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4050",
    "data-name": "Group 4050"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1971",
    "data-name": "Path 1971",
    d: "M228.9,383.742c-.082-.045.493-1.134,1.117-3.011a39.313,39.313,0,0,0,1.622-7.537,27.743,27.743,0,0,0-.038-7.679,8.022,8.022,0,0,0-.674-2.2,4.111,4.111,0,0,1-.436-.736c.015-.022.263.177.611.633a6.941,6.941,0,0,1,.86,2.231,24.344,24.344,0,0,1,.2,7.813,32.546,32.546,0,0,1-1.793,7.6,16.023,16.023,0,0,1-.989,2.156A2.853,2.853,0,0,1,228.9,383.742Z",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4051",
    "data-name": "Group 4051"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1972",
    "data-name": "Path 1972",
    d: "M218.071,368.545a9.28,9.28,0,0,1,1.953-.63,32.6,32.6,0,0,0,4.608-1.648c3.468-1.616,5.739-3.844,5.86-3.691a6.674,6.674,0,0,1-1.447,1.468,18.745,18.745,0,0,1-4.194,2.7,22.644,22.644,0,0,1-4.738,1.532A7.158,7.158,0,0,1,218.071,368.545Z",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4052",
    "data-name": "Group 4052"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1973",
    "data-name": "Path 1973",
    d: "M231.3,295.89a.9.9,0,0,1-.136.213c-.117.158-.261.352-.439.59-.388.516-.954,1.284-1.624,2.311a51.344,51.344,0,0,0-4.735,9.215,119.553,119.553,0,0,0-4.575,14.7c-1.485,5.607-2.958,11.858-5.509,18.1-2.587,6.215-5.766,11.782-7.824,17.2a42.239,42.239,0,0,0-3.118,14.951,26.006,26.006,0,0,0,.667,5.839,24.8,24.8,0,0,0,1.426,4.213,26.2,26.2,0,0,0,1.287,2.507l.362.64a.884.884,0,0,1,.108.229.936.936,0,0,1-.153-.2c-.109-.164-.242-.366-.406-.615a21.113,21.113,0,0,1-1.382-2.477,23.78,23.78,0,0,1-1.524-4.227,25.735,25.735,0,0,1-.753-5.906,41.964,41.964,0,0,1,3.038-15.125c2.051-5.47,5.224-11.056,7.791-17.227,2.529-6.188,4.015-12.419,5.526-18.024a114.764,114.764,0,0,1,4.7-14.72,48.513,48.513,0,0,1,4.908-9.189c.7-1.014,1.294-1.765,1.71-2.262l.48-.559C231.23,295.945,231.289,295.884,231.3,295.89Z",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4053",
    "data-name": "Group 4053"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1974",
    "data-name": "Path 1974",
    d: "M232.98,264.332a10.213,10.213,0,0,1-.52,1.223,13.877,13.877,0,0,0-.984,3.436,16.443,16.443,0,0,0,.187,5.28c.3,1.986,1.132,4.041,1.694,6.343a10.543,10.543,0,0,1,.3,3.458,20.67,20.67,0,0,1-.514,3.168,49.157,49.157,0,0,1-1.547,5.17c-.511,1.447-.963,2.6-1.282,3.4a6.656,6.656,0,0,1-.545,1.216,6.529,6.529,0,0,1,.355-1.285l1.122-3.444c.456-1.456,1-3.194,1.429-5.158a13.454,13.454,0,0,0,.179-6.4c-.543-2.234-1.375-4.345-1.66-6.38a16.046,16.046,0,0,1-.078-5.42,12.3,12.3,0,0,1,1.165-3.464,8.316,8.316,0,0,1,.493-.86C232.893,264.418,232.965,264.323,232.98,264.332Z",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4054",
    "data-name": "Group 4054"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1975",
    "data-name": "Path 1975",
    d: "M234.2,294.415a12.436,12.436,0,0,0,2.517-4.253,15.9,15.9,0,0,0,.787-5.3,36.85,36.85,0,0,0-.828-6.576,62.487,62.487,0,0,1-1.1-6.618,25.894,25.894,0,0,1,.106-5.493,15.206,15.206,0,0,1,.878-3.6,7.668,7.668,0,0,1,.427-.914c.112-.2.178-.3.194-.295.044.022-.168.454-.43,1.276a17.7,17.7,0,0,0-.7,3.575,27.741,27.741,0,0,0,.006,5.407c.185,2.026.686,4.23,1.136,6.561a34.858,34.858,0,0,1,.8,6.675,15.577,15.577,0,0,1-.92,5.427,10.373,10.373,0,0,1-1.86,3.212,7.044,7.044,0,0,1-.718.71C234.309,294.357,234.212,294.428,234.2,294.415Z",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4055",
    "data-name": "Group 4055"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1976",
    "data-name": "Path 1976",
    d: "M259.56,286.537a5.692,5.692,0,0,1-1.208.223c-.78.1-1.907.276-3.292.517a68.2,68.2,0,0,0-20.669,7.126c-1.24.663-2.233,1.221-2.912,1.621a5.568,5.568,0,0,1-1.088.569,5.52,5.52,0,0,1,.981-.74c.647-.454,1.616-1.064,2.84-1.772A58.594,58.594,0,0,1,255,286.914c1.4-.2,2.54-.314,3.329-.356A5.514,5.514,0,0,1,259.56,286.537Z",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4056",
    "data-name": "Group 4056"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1977",
    "data-name": "Path 1977",
    d: "M261.189,275.633c0,.1-1.475.075-3.807.437a28.517,28.517,0,0,0-4.026.943,28.158,28.158,0,0,0-8.92,4.677,28.3,28.3,0,0,0-3.065,2.776c-1.625,1.712-2.444,2.94-2.525,2.883a3.976,3.976,0,0,1,.522-.9,18.919,18.919,0,0,1,1.732-2.235,25.024,25.024,0,0,1,3.038-2.9,26.353,26.353,0,0,1,9.078-4.76,25.026,25.026,0,0,1,4.115-.848,19.054,19.054,0,0,1,2.824-.154A3.946,3.946,0,0,1,261.189,275.633Z",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4057",
    "data-name": "Group 4057"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1978",
    "data-name": "Path 1978",
    d: "M263.425,298.508a5.385,5.385,0,0,1-1.126.433c-.735.24-1.794.6-3.1,1.063a90.786,90.786,0,0,0-19.3,9.51c-1.159.75-2.09,1.371-2.728,1.807a5.365,5.365,0,0,1-1.029.629,5.405,5.405,0,0,1,.909-.793c.6-.488,1.505-1.156,2.643-1.949a73.835,73.835,0,0,1,19.385-9.553c1.322-.42,2.4-.728,3.156-.909A5.426,5.426,0,0,1,263.425,298.508Z",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4058",
    "data-name": "Group 4058"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1979",
    "data-name": "Path 1979",
    d: "M294.949,272.345a5.976,5.976,0,0,1-.962-.338c-.621-.233-1.53-.578-2.7-.966a50.734,50.734,0,0,0-9.99-2.191l.251-.227c.114,4.3.09,9.417-.3,14.865a122.254,122.254,0,0,1-2.11,15.808l-.005-.107a77.279,77.279,0,0,0,3.324,8.881c.469,1.041.9,1.821,1.2,2.355a5.42,5.42,0,0,1,.461.816,4.767,4.767,0,0,1-.573-.746,22.973,22.973,0,0,1-1.311-2.316,67.178,67.178,0,0,1-3.514-8.861l-.017-.05.011-.057a133.593,133.593,0,0,0,2.018-15.759c.384-5.429.435-10.526.368-14.819l0-.259.256.033a46.692,46.692,0,0,1,10.019,2.388c1.169.426,2.066.811,2.672,1.086A5.483,5.483,0,0,1,294.949,272.345Z",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4059",
    "data-name": "Group 4059"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1980",
    "data-name": "Path 1980",
    d: "M295.764,276.675a11.488,11.488,0,0,1-2.1-.574c-1.284-.385-3.069-.876-5.061-1.345-3.986-.934-7.262-1.533-7.236-1.69a8.76,8.76,0,0,1,2.179.193c1.334.193,3.171.516,5.177.99A25.969,25.969,0,0,1,295.764,276.675Z",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4060",
    "data-name": "Group 4060"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1981",
    "data-name": "Path 1981",
    d: "M290.957,261.286a31.654,31.654,0,0,1-3.171-.735,53.735,53.735,0,0,0-7.717-1.229,61.8,61.8,0,0,0-7.821-.1,27.827,27.827,0,0,1-3.254.122,2.845,2.845,0,0,1,.857-.2c.557-.1,1.367-.2,2.372-.293a46.287,46.287,0,0,1,7.889-.047,41.665,41.665,0,0,1,7.766,1.391c.971.277,1.749.53,2.276.733A2.854,2.854,0,0,1,290.957,261.286Z",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4061",
    "data-name": "Group 4061"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1982",
    "data-name": "Path 1982",
    d: "M270.609,265.8a6.734,6.734,0,0,1-1.325.415c-.864.224-2.125.512-3.7.785a50.237,50.237,0,0,1-12.456.62c-2.41-.235-4.818-.5-6.7-1.679a5.693,5.693,0,0,1-2.085-2.263,4.3,4.3,0,0,1-.358-2.655,14.162,14.162,0,0,1,1.118-3.634,4.041,4.041,0,0,1,.71-1.2c.034.021-.209.449-.523,1.277a16.126,16.126,0,0,0-.94,3.6,3.963,3.963,0,0,0,.379,2.415,5.331,5.331,0,0,0,1.953,2.048c1.747,1.074,4.1,1.338,6.49,1.567a56.06,56.06,0,0,0,12.355-.465c1.572-.225,2.838-.456,3.712-.619A7.484,7.484,0,0,1,270.609,265.8Z",
    fill: "#455a64"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4155",
    "data-name": "Group 4155"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4150",
    "data-name": "Group 4150"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1983",
    "data-name": "Path 1983",
    d: "M268.06,86.56c-4.78-10.356-16.609-8.316-22.27-5.566A24.934,24.934,0,0,0,233.281,94.24c-1.665,4-2.985,8.562-6.338,10.978a48.98,48.98,0,0,1-4.758,2.476,6.155,6.155,0,0,0-3.322,4.208c-.5,3.445,2.961,5.834,5.882,7.224-1.736,1.181-2.189,3.854-1.579,5.99a15.344,15.344,0,0,0,3.421,5.5,84.959,84.959,0,0,0,17.353,14.638c5.46,3.394,8.993,3.8,14.86,1.356,2.384-.992,4.6-2.617,7.139-2.907,2.947-.336,5.776,1.181,8.686,1.786s6.6-.228,7.553-3.3a22.017,22.017,0,0,0,.4-3.7c.159-1.234.763-2.572,1.872-2.853.9-.229,1.8.317,2.686.612,2.108.7,5.285,16.362,7.309,15.409,0,0,2.939-26.545-2.725-42.068-1.807-4.951-5.665-15.523-8.752-19.634-4.238-5.645-14.4-4.392-14.906-3.39",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4149",
    "data-name": "Group 4149"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4148",
    "data-name": "Group 4148"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1984",
    "data-name": "Path 1984",
    d: "M261.995,88.281c-7.525-2.627-17.684,3.148-19.99,10.777-2.561,8.476-5.355,18.926-5.843,25.585C235.182,138.032,244.69,142,244.69,142l-3.873,20.929,32.636-10.549,11.39-49.314,1.06-4.148Z",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4076",
    "data-name": "Group 4076"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4075",
    "data-name": "Group 4075"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4074",
    "data-name": "Group 4074"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4073",
    "data-name": "Group 4073"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4072",
    "data-name": "Group 4072"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4071",
    "data-name": "Group 4071"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4070",
    "data-name": "Group 4070"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4069",
    "data-name": "Group 4069"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4068",
    "data-name": "Group 4068"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4067",
    "data-name": "Group 4067"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4066",
    "data-name": "Group 4066"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4065",
    "data-name": "Group 4065"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4064",
    "data-name": "Group 4064"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1985",
    "data-name": "Path 1985",
    d: "M242.007,109.383c.115.284,1.663-.133,3.364.541,1.709.648,2.615,2.015,2.882,1.879.127-.057.074-.508-.315-1.118a4.664,4.664,0,0,0-2.207-1.759,4.482,4.482,0,0,0-2.779-.173C242.271,108.949,241.947,109.253,242.007,109.383Z",
    fill: "#263238"
  })))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4089",
    "data-name": "Group 4089"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4088",
    "data-name": "Group 4088"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4087",
    "data-name": "Group 4087"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4086",
    "data-name": "Group 4086"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4085",
    "data-name": "Group 4085"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4084",
    "data-name": "Group 4084"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4083",
    "data-name": "Group 4083"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4082",
    "data-name": "Group 4082"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4081",
    "data-name": "Group 4081"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4080",
    "data-name": "Group 4080"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4079",
    "data-name": "Group 4079"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4078",
    "data-name": "Group 4078"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4077",
    "data-name": "Group 4077"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1986",
    "data-name": "Path 1986",
    d: "M258.893,113.827c.2.235,1.547-.628,3.37-.5,1.825.1,3.1,1.132,3.315.922.1-.092-.081-.506-.638-.97a4.653,4.653,0,0,0-2.634-1.012,4.483,4.483,0,0,0-2.7.674C259.015,113.334,258.8,113.721,258.893,113.827Z",
    fill: "#263238"
  })))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4101",
    "data-name": "Group 4101"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4100",
    "data-name": "Group 4100"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4099",
    "data-name": "Group 4099"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4098",
    "data-name": "Group 4098"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4097",
    "data-name": "Group 4097"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4096",
    "data-name": "Group 4096"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4095",
    "data-name": "Group 4095"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4094",
    "data-name": "Group 4094"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4093",
    "data-name": "Group 4093"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4092",
    "data-name": "Group 4092"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4091",
    "data-name": "Group 4091"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4090",
    "data-name": "Group 4090"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1987",
    "data-name": "Path 1987",
    d: "M251.314,121.319a12.091,12.091,0,0,0-2.771-1.2c-.444-.153-.853-.345-.857-.673a2.381,2.381,0,0,1,.62-1.277l2.159-3.148c3.026-4.494,5.33-8.231,5.148-8.351s-2.783,3.423-5.809,7.917q-1.1,1.665-2.106,3.182a2.7,2.7,0,0,0-.655,1.73,1.174,1.174,0,0,0,.592.84,3.119,3.119,0,0,0,.747.289A11.963,11.963,0,0,0,251.314,121.319Z",
    fill: "#263238"
  }))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4112",
    "data-name": "Group 4112"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4111",
    "data-name": "Group 4111"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4110",
    "data-name": "Group 4110"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4109",
    "data-name": "Group 4109"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4108",
    "data-name": "Group 4108"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4107",
    "data-name": "Group 4107"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4106",
    "data-name": "Group 4106"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4105",
    "data-name": "Group 4105"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4104",
    "data-name": "Group 4104"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4103",
    "data-name": "Group 4103"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4102",
    "data-name": "Group 4102"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1988",
    "data-name": "Path 1988",
    d: "M244.688,142.033a35.1,35.1,0,0,0,18.817-.476s-6.338,8.062-19.42,3.743Z",
    fill: "#eb996e"
  })))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4113",
    "data-name": "Group 4113"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1989",
    "data-name": "Path 1989",
    d: "M250.339,127.3c-.174-.223.079.268,0,0Z",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1990",
    "data-name": "Path 1990",
    d: "M256.151,126.43a3.356,3.356,0,0,0-1.974-1.742,3.681,3.681,0,0,0-3.525.577,2.276,2.276,0,0,0-.313,2.036c.63.8.689,1.488,1.575,1.98a4.6,4.6,0,0,0,3.839-.444A2.129,2.129,0,0,0,256.151,126.43Z",
    fill: "#eb996e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4125",
    "data-name": "Group 4125"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4124",
    "data-name": "Group 4124"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4123",
    "data-name": "Group 4123"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4122",
    "data-name": "Group 4122"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4121",
    "data-name": "Group 4121"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4120",
    "data-name": "Group 4120"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4119",
    "data-name": "Group 4119"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4118",
    "data-name": "Group 4118"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4117",
    "data-name": "Group 4117"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4116",
    "data-name": "Group 4116"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4115",
    "data-name": "Group 4115"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4114",
    "data-name": "Group 4114"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1991",
    "data-name": "Path 1991",
    d: "M256.267,123.782c-.286-.085-.743,1.847-2.721,2.831s-3.985.288-4.064.555c-.055.115.371.483,1.236.711a4.945,4.945,0,0,0,3.366-.353,4.311,4.311,0,0,0,2.158-2.4C256.506,124.331,256.4,123.8,256.267,123.782Z",
    fill: "#263238"
  }))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4133",
    "data-name": "Group 4133"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4132",
    "data-name": "Group 4132"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4131",
    "data-name": "Group 4131"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4130",
    "data-name": "Group 4130"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4129",
    "data-name": "Group 4129"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4128",
    "data-name": "Group 4128"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4127",
    "data-name": "Group 4127"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4126",
    "data-name": "Group 4126"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1992",
    "data-name": "Path 1992",
    d: "M262.565,104.4c-.1.512,1.4,1.041,2.9,2.135,1.527,1.058,2.543,2.311,2.968,2.032.2-.138.188-.672-.115-1.38a5.458,5.458,0,0,0-1.831-2.2,5.182,5.182,0,0,0-2.64-.974C263.1,103.977,262.618,104.162,262.565,104.4Z",
    fill: "#263238"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4141",
    "data-name": "Group 4141"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4140",
    "data-name": "Group 4140"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4139",
    "data-name": "Group 4139"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4138",
    "data-name": "Group 4138"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4137",
    "data-name": "Group 4137"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4136",
    "data-name": "Group 4136"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4135",
    "data-name": "Group 4135"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4134",
    "data-name": "Group 4134"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1993",
    "data-name": "Path 1993",
    d: "M243.1,102.528c.4.379,1.761-.185,3.448-.367,1.68-.235,3.145-.021,3.433-.485.123-.224-.141-.617-.8-.949a5.523,5.523,0,0,0-5.544.686C243.073,101.9,242.918,102.341,243.1,102.528Z",
    fill: "#263238"
  }))))))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1994",
    "data-name": "Path 1994",
    d: "M287.734,98.886a5.178,5.178,0,0,0-2.5-2.223,167.348,167.348,0,0,0-20.122-9.36l-2.842,1.607a14.106,14.106,0,0,0,6.9,14.083c1.941,1.082,4.462,2.1,4.713,4.3.26,2.287-2.137,3.849-3.495,5.708a7.219,7.219,0,0,0-.223,7.974c.873,1.348,2.19,2.374,2.99,3.766a7.129,7.129,0,0,1,.266,6.162c-.806,1.971-2.162,4.631-3.975,5.747a12.234,12.234,0,0,0,13.091-5.519c1.514-2.579,1.634-5.709,1.836-8.693a111.662,111.662,0,0,1,3.23-20.157A5.382,5.382,0,0,0,287.734,98.886Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4147",
    "data-name": "Group 4147"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4146",
    "data-name": "Group 4146"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4145",
    "data-name": "Group 4145"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4144",
    "data-name": "Group 4144"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4143",
    "data-name": "Group 4143"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4142",
    "data-name": "Group 4142"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1995",
    "data-name": "Path 1995",
    d: "M265.564,87.613a27.825,27.825,0,0,1-6.237,5.99c-2.458,1.53-5.6,2.249-8.286,1.17l2.019-2.228a41.79,41.79,0,0,1-15.908,6.578c3.58-4.351,7.272-8.8,12.158-11.605s11.3-3.672,16.074-.68",
    fill: "#263238"
  })))))))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1996",
    "data-name": "Path 1996",
    d: "M288.395,112.9l-15.243,11.841c1.748,1.9,1.064,6.765-.649,8.7s-4,3.579-4.673,6.073c-.739,2.733.71,5.563.752,8.393.059,4.007-2.636,7.437-4.714,10.863s-3.575,8-1.259,11.265c2.607,3.68,8.522,3.154,12.092.4s5.609-6.988,8.263-10.635,6.79-6.429,11.277-5.974A86.29,86.29,0,0,0,288.395,112.9Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4151",
    "data-name": "Group 4151"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1997",
    "data-name": "Path 1997",
    d: "M290.942,145.908c-.094-.166.807-.822,2.349-2.054a30.364,30.364,0,0,0,5.756-5.845,19.193,19.193,0,0,0,2.576-4.885,15.583,15.583,0,0,0,.9-6.125,13.83,13.83,0,0,0-2.1-6.383,21.465,21.465,0,0,0-5.062-5.458c-4.107-3.187-8.96-5.017-13.284-6.9a47.962,47.962,0,0,1-11.184-6.14,20.452,20.452,0,0,1-5.689-6.554c-.928-1.849-1.083-2.994-.938-3.042.191-.074.669.932,1.8,2.511a23.683,23.683,0,0,0,5.915,5.6A53.554,53.554,0,0,0,283,106.037c2.186.872,4.515,1.77,6.894,2.878a35.907,35.907,0,0,1,7.072,4.188,23.2,23.2,0,0,1,5.642,6.186,15.9,15.9,0,0,1,2.315,7.593,17.2,17.2,0,0,1-1.278,7,19.834,19.834,0,0,1-3.14,5.249,24.564,24.564,0,0,1-6.641,5.556C292.1,145.7,291.024,146.055,290.942,145.908Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4152",
    "data-name": "Group 4152"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1998",
    "data-name": "Path 1998",
    d: "M291.23,109.965a7.147,7.147,0,0,1-1.326-.433c-.84-.311-2.05-.778-3.529-1.4a44.834,44.834,0,0,1-10.895-6.2,22.194,22.194,0,0,1-7.235-10.162,14.805,14.805,0,0,1-.707-3.75,8.766,8.766,0,0,1-.005-1.037c.01-.237.024-.361.042-.361a22.881,22.881,0,0,0,1.02,5.031,22.824,22.824,0,0,0,7.215,9.875,49.271,49.271,0,0,0,10.712,6.266l3.459,1.549A7.114,7.114,0,0,1,291.23,109.965Z",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4153",
    "data-name": "Group 4153"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1999",
    "data-name": "Path 1999",
    d: "M291.709,125.145c-.057-.022.246-.6.408-1.728a8.486,8.486,0,0,0-.806-4.668,13.4,13.4,0,0,0-4.622-5.321c-2.191-1.586-4.913-2.852-7.632-4.474a27.261,27.261,0,0,1-6.812-5.748,27.943,27.943,0,0,1-3.968-6.1,25.039,25.039,0,0,1-1.668-4.612c-.158-.557-.222-1-.283-1.3a1.588,1.588,0,0,1-.056-.462,16.95,16.95,0,0,1,.534,1.709,28.575,28.575,0,0,0,5.8,10.457,27.579,27.579,0,0,0,6.717,5.615c2.682,1.6,5.421,2.89,7.644,4.531a13.516,13.516,0,0,1,4.678,5.56,8.361,8.361,0,0,1,.67,4.85,5.25,5.25,0,0,1-.39,1.283A1.576,1.576,0,0,1,291.709,125.145Z",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4154",
    "data-name": "Group 4154"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2000",
    "data-name": "Path 2000",
    d: "M207.442,114.974c-.007,0,.024-.06.092-.164a3.573,3.573,0,0,1,.328-.441,4.454,4.454,0,0,1,1.7-1.257,10.032,10.032,0,0,1,3.3-.569c1.287-.077,2.772-.173,4.4-.174a23.892,23.892,0,0,0,5.251-.485,12.971,12.971,0,0,0,5.271-2.778,23.131,23.131,0,0,0,4.3-5.1,69.209,69.209,0,0,0,3.435-6.36,51.7,51.7,0,0,1,3.594-6.345,19.456,19.456,0,0,1,4.723-4.911,19.734,19.734,0,0,1,10.848-3.546,18.652,18.652,0,0,1,7.606,1.341l1.113.495.777.437a3.784,3.784,0,0,1,.621.39,4,4,0,0,1-.671-.3l-.793-.389-1.121-.446a19.163,19.163,0,0,0-7.52-1.161,19.575,19.575,0,0,0-10.58,3.567,19.14,19.14,0,0,0-4.584,4.811,52.455,52.455,0,0,0-3.547,6.288,68.039,68.039,0,0,1-3.471,6.4,23.39,23.39,0,0,1-4.416,5.185,13.322,13.322,0,0,1-5.481,2.832,23.729,23.729,0,0,1-5.348.433c-1.632-.022-3.093.047-4.392.1a10.216,10.216,0,0,0-3.234.466,4.625,4.625,0,0,0-1.7,1.14C207.61,114.782,207.463,114.99,207.442,114.974Z",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4159",
    "data-name": "Group 4159"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2001",
    "data-name": "Path 2001",
    d: "M201.319,101.515c-6.013-15.15-13.959-30-15.1-41.3l-11.955.488c.257,4.365,1.819,40.741,10.293,55.121s36.747,48.005,36.747,48.005l9.95-25.6S207.332,116.665,201.319,101.515Z",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2002",
    "data-name": "Path 2002",
    d: "M181.4,36.7h-5.231s.507,3.079,2.881,3.249,1.906-.365,1.906-.365l-.532.481-3.262.647s.17,2.543,2.317,2.938l3.164-2.938Z",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2003",
    "data-name": "Path 2003",
    d: "M195.72,36.244c-.479,3.931-.534,3.695-.534,3.695l-4.779,3.943-1.215-5.806a1.788,1.788,0,0,0-1.64-1.418l-2.176-.136s.847-3.017-1.882-2.753c0,0-1.5-.41-2.71,4.616-1.32,5.481-7.016,18.382-6.518,22.7l12.122.482c-.126-4.024,3.177-8.268,4.8-10.105a4.4,4.4,0,0,0,1.012-1.932,5.961,5.961,0,0,1,1.359-2.659c1.495-1.66,4.649-4.649,4.649-4.649V33.087S196.183,32.439,195.72,36.244Zm-9.74,8.819-2.486,1.13.419-2.543,2.067-.2Z",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4156",
    "data-name": "Group 4156"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2004",
    "data-name": "Path 2004",
    d: "M183.384,46.458a4.22,4.22,0,0,1,.121-1.072c.111-.684.289-1.67.519-2.885.247-1.257.528-2.693.836-4.265a17.136,17.136,0,0,0,.411-2.482c.022-.812-.3-1.748-1.173-1.8-.815-.146-1.512.541-1.925,1.254a5.346,5.346,0,0,0-.481,1.158l-.392,1.189L180,41.705c-.388,1.178-.748,2.117-1.024,2.755a3.9,3.9,0,0,1-.49.963,4.869,4.869,0,0,1,.3-1.035c.217-.656.521-1.606.862-2.792.352-1.232.754-2.639,1.194-4.181q.185-.59.378-1.2a5.783,5.783,0,0,1,.513-1.259,3.783,3.783,0,0,1,.938-1.106,1.969,1.969,0,0,1,1.5-.4,1.993,1.993,0,0,1,.764.27,1.649,1.649,0,0,1,.537.61,2.914,2.914,0,0,1,.305,1.441,16.439,16.439,0,0,1-.451,2.571c-.348,1.564-.667,2.993-.945,4.242-.277,1.206-.51,2.18-.682,2.851A4.306,4.306,0,0,1,183.384,46.458Z",
    fill: "#eb996e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4157",
    "data-name": "Group 4157"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2005",
    "data-name": "Path 2005",
    d: "M185.859,45.092a20.548,20.548,0,0,1-.144-2.942c-.026-.4-.06-.783-.1-1.131s-.075-.6-.227-.725c-.338-.252-.751-.255-.726-.345,0-.035.084-.07.241-.088a1.121,1.121,0,0,1,.7.134,1.275,1.275,0,0,1,.488.956,9.983,9.983,0,0,1,.141,1.166A5.552,5.552,0,0,1,185.859,45.092Z",
    fill: "#eb996e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4158",
    "data-name": "Group 4158"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2006",
    "data-name": "Path 2006",
    d: "M191.795,42.856c.044.055-.325.444-.982,1.011a12.43,12.43,0,0,1-2.846,1.879,9.518,9.518,0,0,1-3.329.789,3.569,3.569,0,0,1-1.41-.036,4.192,4.192,0,0,1,1.364-.329,12.77,12.77,0,0,0,3.159-.9,19.242,19.242,0,0,0,2.838-1.7C191.3,43.087,191.75,42.8,191.795,42.856Z",
    fill: "#eb996e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4165",
    "data-name": "Group 4165"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2007",
    "data-name": "Path 2007",
    d: "M286.832,156.436s13.453-.4,21.52-2.791,39.038-9.767,39.038-9.767l49.629-8.282L398,148.442s-46.126,13.488-55.09,16.563-49.924,17.116-57.648,15.338l-4.8-9.874Z",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4164",
    "data-name": "Group 4164"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2008",
    "data-name": "Path 2008",
    d: "M420.872,120.5c-.807-.179-4.834,1.649-4.834,1.649a2.679,2.679,0,0,0,.085-3.317l-5.522,2.709a56.5,56.5,0,0,1-4.61,4.184,63.2,63.2,0,0,0-7.043,7.611l-3.295,3.067L397.7,148.56a10.23,10.23,0,0,0,4.317-.568c1.7-.795,4.2-3.976,4.2-3.976l4.713-.4a2.633,2.633,0,0,0,1.5-.589,3.923,3.923,0,0,0,1.173-3.213c2.953-1.7,1.249-3.862,1.249-3.862a3.7,3.7,0,0,0,2.42-1.335,2.259,2.259,0,0,0-.148-2.641c-.568-1.022-4.884-.681-4.884-.681l-.228-1.25s6.6-5.244,8.074-6.38S421.633,120.671,420.872,120.5Z",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4160",
    "data-name": "Group 4160"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2009",
    "data-name": "Path 2009",
    d: "M416.123,122.031a7.144,7.144,0,0,1-2.03,2.421,24.455,24.455,0,0,0-2.416,2.355,10,10,0,0,0-1.763,3.647,19.835,19.835,0,0,1-1.487,3.947,13.624,13.624,0,0,1-2,2.816,12.015,12.015,0,0,1-1.733,1.548,2.327,2.327,0,0,1-.734.435c-.056-.073.944-.763,2.191-2.227A14.787,14.787,0,0,0,408,134.179a21.5,21.5,0,0,0,1.415-3.879,10,10,0,0,1,1.892-3.8,20.766,20.766,0,0,1,2.542-2.325A27.494,27.494,0,0,0,416.123,122.031Z",
    fill: "#eb996e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4161",
    "data-name": "Group 4161"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2010",
    "data-name": "Path 2010",
    d: "M413.7,139.758a7.162,7.162,0,0,1-2.208,1.039,10.709,10.709,0,0,1-2.617.54,9.17,9.17,0,0,1-1.593-.02,3.449,3.449,0,0,1-1.683-.577,1.946,1.946,0,0,1-.845-1.641,2.456,2.456,0,0,1,.885-1.457,2.915,2.915,0,0,1,1.3-.731c.433-.118.834-.207,1.2-.284a6.811,6.811,0,0,1,2.419-.276c0,.055-.9.235-2.334.634-.358.1-.752.208-1.163.339a2.516,2.516,0,0,0-1.1.669,2.107,2.107,0,0,0-.7,1.134,1.464,1.464,0,0,0,.642,1.193,5.027,5.027,0,0,0,2.941.538,12.016,12.016,0,0,0,2.54-.414C412.806,140.05,413.662,139.68,413.7,139.758Z",
    fill: "#eb996e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4162",
    "data-name": "Group 4162"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2011",
    "data-name": "Path 2011",
    d: "M414.973,135.931a4.082,4.082,0,0,1-1.7.514,10.991,10.991,0,0,1-1.932.139,2.962,2.962,0,0,1-2.3-.886,2.291,2.291,0,0,1-.1-2.478,3.3,3.3,0,0,1,1.472-1.357,3.639,3.639,0,0,1,1.715-.493c.031.083-.629.284-1.535.814a3.138,3.138,0,0,0-1.224,1.253,1.857,1.857,0,0,0,.076,1.935,2.61,2.61,0,0,0,1.918.732,14.454,14.454,0,0,0,1.868-.025A11.319,11.319,0,0,1,414.973,135.931Z",
    fill: "#eb996e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4163",
    "data-name": "Group 4163"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2012",
    "data-name": "Path 2012",
    d: "M411.737,143.433a4.51,4.51,0,0,1-1.386.43,11.91,11.91,0,0,1-3.5.421,1.36,1.36,0,0,1-1.071-.458,1.531,1.531,0,0,1-.306-1.036,1.938,1.938,0,0,1,.842-1.475c.874-.533,1.52-.209,1.476-.169a2.929,2.929,0,0,0-1.257.465,1.629,1.629,0,0,0-.581,1.2,1.081,1.081,0,0,0,.222.695.864.864,0,0,0,.706.26,17.337,17.337,0,0,0,3.4-.263A3.753,3.753,0,0,1,411.737,143.433Z",
    fill: "#eb996e"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4178",
    "data-name": "Group 4178"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4166",
    "data-name": "Group 4166"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2013",
    "data-name": "Path 2013",
    d: "M263.98,199.067a3.846,3.846,0,0,1-.936.542,17.581,17.581,0,0,1-2.755,1.053,20.83,20.83,0,0,1-9.678.474,20.382,20.382,0,0,1-8.812-4.029,16.942,16.942,0,0,1-2.15-2.021,3.822,3.822,0,0,1-.656-.86c.072-.068,1.055,1.126,3.03,2.589a21.543,21.543,0,0,0,8.685,3.81,22.067,22.067,0,0,0,9.483-.318C262.573,199.7,263.94,198.977,263.98,199.067Z",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2014",
    "data-name": "Path 2014",
    d: "M241.273,162.088s31.64-10.12,32.821-10.434,29.084,2.171,29.084,2.171-1.2,18.49,5.86,24.47h0l-20.525,7.4-6.476,17.812s-3.611,7.262-.742,14.072c5.431,12.891,14.857,33.23,13.463,35.557-.146.244-.954-7.048-14.388-10.846-4.056-1.146-11.434-1.161-18.1.182-28.7,5.783-39.778,19.038-43.049,21.31,0,0,5.907-46.367,3.115-53.607s-5.748-11.961-3.449-18.414,5.756-16.735,5.756-16.735L213.34,162.2l15.8-26.273L243.6,147.914Z",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4167",
    "data-name": "Group 4167"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2015",
    "data-name": "Path 2015",
    d: "M251.787,205.05a3.825,3.825,0,0,1-1.088.048,16.362,16.362,0,0,1-2.946-.378,18.321,18.321,0,0,1-8.622-4.525,17.119,17.119,0,0,1-4.866-8.426,14.5,14.5,0,0,1-.4-2.945,3.771,3.771,0,0,1,.053-1.088,36.731,36.731,0,0,0,.7,3.941,17.754,17.754,0,0,0,4.869,8.14,19.123,19.123,0,0,0,8.348,4.545C250.235,204.97,251.794,204.95,251.787,205.05Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4168",
    "data-name": "Group 4168"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2016",
    "data-name": "Path 2016",
    d: "M222.081,165.847a12.537,12.537,0,0,1,1.675,11.311,27.779,27.779,0,0,0,.012-5.781A28.574,28.574,0,0,0,222.081,165.847Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4169",
    "data-name": "Group 4169"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2017",
    "data-name": "Path 2017",
    d: "M289.231,171.329c.049.076-.653.535-1.611,1.458A13.74,13.74,0,0,0,284.672,177a13.123,13.123,0,0,0-1.125,5.014c-.024,1.33.134,2.154.044,2.171a5.4,5.4,0,0,1-.412-2.166,11.69,11.69,0,0,1,1.017-5.23,12.129,12.129,0,0,1,3.176-4.277A5.6,5.6,0,0,1,289.231,171.329Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4170",
    "data-name": "Group 4170",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2018",
    "data-name": "Path 2018",
    d: "M247.089,204.363a14.528,14.528,0,0,1-7.915-4.483,16.215,16.215,0,0,1-3.433-4.747c-.72,3.14,3.646,8.707,7.907,10.753a15.349,15.349,0,0,0,13.72-.371A51.674,51.674,0,0,1,247.089,204.363Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4171",
    "data-name": "Group 4171"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2019",
    "data-name": "Path 2019",
    d: "M285.843,227.341c-.036.055-.834-.566-2.472-1.31a18.842,18.842,0,0,0-7.39-1.54,27.459,27.459,0,0,0-10.97,2.227,71.176,71.176,0,0,0-12,6.886A126.585,126.585,0,0,1,230.9,245.868c-2.978,1.275-5.437,2.184-7.148,2.777-.853.3-1.524.512-1.979.655a3.843,3.843,0,0,1-.7.19,3.83,3.83,0,0,1,.668-.29l1.943-.746c1.687-.649,4.121-1.609,7.071-2.923a135.527,135.527,0,0,0,21.964-12.36,69.483,69.483,0,0,1,12.112-6.9,27.324,27.324,0,0,1,11.161-2.151,18.315,18.315,0,0,1,7.466,1.724A11.34,11.34,0,0,1,285.843,227.341Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4172",
    "data-name": "Group 4172"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2020",
    "data-name": "Path 2020",
    d: "M280.118,210.76a18.153,18.153,0,0,0-1.9-1.48,13.326,13.326,0,0,0-6.171-1.944,21.223,21.223,0,0,0-9.46,1.745,113.822,113.822,0,0,0-10.71,5.336,101.773,101.773,0,0,1-10.832,5.224,40.9,40.9,0,0,1-9.494,2.54,27.289,27.289,0,0,1-6.625.109c-.778-.1-1.378-.193-1.78-.289a2.745,2.745,0,0,1-.608-.158c.009-.05.857.118,2.406.245a29.541,29.541,0,0,0,6.556-.272,42.118,42.118,0,0,0,9.369-2.621,107.657,107.657,0,0,0,10.762-5.237,107.18,107.18,0,0,1,10.781-5.324,21.205,21.205,0,0,1,9.666-1.665,13.054,13.054,0,0,1,6.252,2.142A7.038,7.038,0,0,1,280.118,210.76Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4173",
    "data-name": "Group 4173"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2021",
    "data-name": "Path 2021",
    d: "M237.876,198.162c.02.029-.206.213-.638.521a6.348,6.348,0,0,1-.815.519,10.764,10.764,0,0,1-1.134.6,16.7,16.7,0,0,1-3.148,1.114,18.217,18.217,0,0,1-8.131.119,16.819,16.819,0,0,1-3.179-1.02,10.923,10.923,0,0,1-1.152-.562,6.684,6.684,0,0,1-.83-.494c-.441-.3-.673-.472-.654-.5.052-.083,1.035.551,2.774,1.217a19.059,19.059,0,0,0,3.136.89,19.481,19.481,0,0,0,7.927-.115,19.141,19.141,0,0,0,3.108-.983C236.859,198.744,237.822,198.08,237.876,198.162Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4174",
    "data-name": "Group 4174"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2022",
    "data-name": "Path 2022",
    d: "M284.889,195.648a1.9,1.9,0,0,1-.392.338,8.445,8.445,0,0,1-1.254.8A13.873,13.873,0,0,1,278,198.289a23.778,23.778,0,0,1-8.056-.743c-2.968-.716-6.1-1.889-9.456-2.834a43.191,43.191,0,0,0-17.664-1.142,44.86,44.86,0,0,0-5.3,1.09,19.365,19.365,0,0,1-1.929.5,1.9,1.9,0,0,1,.474-.209c.318-.115.781-.3,1.4-.486a37.182,37.182,0,0,1,5.3-1.26,41.715,41.715,0,0,1,17.86,1.005c3.385.954,6.505,2.138,9.433,2.87a24.186,24.186,0,0,0,7.907.841,14.53,14.53,0,0,0,5.182-1.319C284.3,196.049,284.858,195.6,284.889,195.648Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4175",
    "data-name": "Group 4175"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2023",
    "data-name": "Path 2023",
    d: "M284.056,180.643a3.056,3.056,0,0,1-.637.1c-.42.044-1.042.115-1.844.175a35.076,35.076,0,0,1-6.791-.484c-2.842-.458-6.164-1.305-9.821-2.3a75.09,75.09,0,0,0-12.015-2.494,31.831,31.831,0,0,0-3.209-.1c-.527.018-1.052.014-1.569.05l-1.534.183a28.4,28.4,0,0,0-5.709,1.434c-3.556,1.259-6.664,2.706-9.392,3.627a25.525,25.525,0,0,1-6.647,1.463,11.912,11.912,0,0,1-1.853.01,3.059,3.059,0,0,1-.642-.06,3.018,3.018,0,0,1,.644-.045,15.656,15.656,0,0,0,1.834-.107,27.339,27.339,0,0,0,6.541-1.608c2.692-.958,5.772-2.435,9.356-3.733a28.394,28.394,0,0,1,5.8-1.486l1.565-.191c.528-.039,1.063-.036,1.6-.056a32,32,0,0,1,3.264.1,72.327,72.327,0,0,1,12.095,2.549c3.651,1.018,6.944,1.9,9.757,2.4a38.813,38.813,0,0,0,6.724.644l1.839-.076A2.978,2.978,0,0,1,284.056,180.643Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4176",
    "data-name": "Group 4176"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2024",
    "data-name": "Path 2024",
    d: "M294.032,153.812a45.638,45.638,0,0,0-1.893,4.161,21.436,21.436,0,0,0-.973,10.807,21.933,21.933,0,0,0,4.529,9.87c1.774,2.2,3.206,3.247,3.138,3.325a4.893,4.893,0,0,1-1.011-.717,19.329,19.329,0,0,1-2.411-2.373,21.128,21.128,0,0,1-4.759-10.016,20.671,20.671,0,0,1,1.143-11.025,18.611,18.611,0,0,1,1.51-3.028A4.878,4.878,0,0,1,294.032,153.812Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4177",
    "data-name": "Group 4177"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2025",
    "data-name": "Path 2025",
    d: "M241.253,156.954a3,3,0,0,1-.888.2,24.4,24.4,0,0,1-2.463.264,12.976,12.976,0,0,1-3.693-.285,8.2,8.2,0,0,1-3.953-2.252c-1.157-1.139-2.036-2.383-2.93-3.41a11.162,11.162,0,0,0-2.692-2.343,6.807,6.807,0,0,0-3.138-.914,2.037,2.037,0,0,1,.912-.108,5.626,5.626,0,0,1,2.406.7,10.783,10.783,0,0,1,2.873,2.347c.931,1.032,1.822,2.263,2.933,3.355a7.957,7.957,0,0,0,3.707,2.159,13.812,13.812,0,0,0,3.565.382C239.957,157.013,241.245,156.866,241.253,156.954Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4179",
    "data-name": "Group 4179"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2026",
    "data-name": "Path 2026",
    d: "M239.242,461.525c-.144,0-.261-10.483-.261-23.41s.117-23.413.261-23.413.26,10.481.26,23.413S239.385,461.525,239.242,461.525Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4180",
    "data-name": "Group 4180"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2027",
    "data-name": "Path 2027",
    d: "M243.669,449.493c-.144,0-.261-10.483-.261-23.41s.117-23.413.261-23.413.26,10.48.26,23.413S243.812,449.493,243.669,449.493Z",
    fill: "#263238"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappycustomer);
export default __webpack_public_path__ + "static/media/happycustomer.0477a081be9e00d487d0e39715835374.svg";
export { ForwardRef as ReactComponent };